const blogList = [
  {
    id: 24,
    image: 'assets/images/blog/wordpress-popularity-icon.svg',
    date: '22 May',
    category: 'Tech Docs',
    title: 'Which WordPress Solution is Right for Your Business?',
    titleHe: 'איזה פתרון WordPress מתאים לעסק שלך?',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <p>לא כל אתר WordPress צריך את אותה רמת שירות.</p>
        <p>יש עסקים שצריכים רק סביבת אחסון טובה עם פלטפורמה נוחה לניהול עצמי.<br/>
        יש אתרים שצריכים שרת WordPress מנוהל, מאובטח ומבודד יותר.<br/>
        ויש עסקים שרוצים שננהל עבורם גם את האתר עצמו — עדכונים, תוכן, בקשות, SEO ושיפורים שוטפים.</p>
        <p>כדי לעשות סדר, חילקנו את השירותים שלנו לשלוש רמות ברורות:</p>

        <h4 class="h6 mt-4 mb-2">1. WordPress Hosting</h4>
        <p><strong>אחסון WordPress משותף עם פלטפורמה לניהול עצמי</strong></p>
        <p>חבילות WordPress Hosting מיועדות לעסקים שרוצים לאחסן אתר WordPress בצורה פשוטה, מהירה ומאובטחת — ועדיין לנהל את האתר בעצמם.</p>
        <p>במסלול הזה אתם מקבלים גישה לפלטפורמת ניהול נוחה, התקנת WordPress בקליק, SSL, הגנות בסיסיות, WAF, Malware Protection, Cloudflare Integration, תיבות מייל ובסיסי נתונים לפי החבילה.</p>
        <p>חשוב להבין:<br/>
        זהו <strong>אחסון משותף</strong>. כלומר, האתר שלכם נמצא על שרת שבו קיימים גם אתרים נוספים של לקוחות אחרים. לכל לקוח יש הפרדה וניהול משלו, אבל מבחינת תשתית — המשאבים של השרת משותפים בין כמה לקוחות.</p>
        
        <h5 class="h6 mt-3 mb-2">למי זה מתאים?</h5>
        <ul>
          <li>אתר תדמית קטן או בינוני</li>
          <li>בלוג</li>
          <li>דף נחיתה</li>
          <li>אתר עסקי פשוט</li>
          <li>לקוח שרוצה לנהל את WordPress בעצמו</li>
          <li>מי שמחפש פתרון אחסון במחיר נמוך יחסית</li>
        </ul>
        
        <p><strong>במילים פשוטות</strong><br/>
        זה הפתרון למי שצריך <strong>אחסון WordPress טוב + פלטפורמה לניהול עצמי</strong>, אבל לא צריך שרת פרטי או שירות תחזוקה מלא לאתר.</p>
        <div class="d-flex flex-wrap align-items-center gap-3 mt-2 mb-4">
          <a href="/he/wordpress-hosting" class="btn btn-primary">לכל חבילות WordPress Hosting <i class="las la-arrow-left ms-1"></i></a>
          <span class="fs-5 fw-bold text-primary">החל מ־19.90 ₪ <span class="fs-6 text-muted fw-normal">/ לחודש</span></span>
        </div>

        <h4 class="h6 mt-4 mb-2">2. Managed WordPress Cloud</h4>
        <p><strong>שרת WordPress מנוהל, מבודד, מאובטח וניתן להרחבה</strong></p>
        <p>Managed WordPress Cloud מיועד לאתרים שצריכים יותר מאחסון משותף.</p>
        <p>במקום לחלוק שרת עם לקוחות נוספים, האתר שלכם מקבל סביבת VPS / Cloud מנוהלת עם משאבים מוגדרים, הפרדה טובה יותר מאתרים אחרים, רמת אבטחה גבוהה יותר ויכולת להגדיל משאבים לפי הצורך.</p>
        <p>המסלול הזה מתאים במיוחד לאתרים שחשובים לעסק, אתרי WooCommerce, אתרים עם תנועה גבוהה, מערכות הזמנות, אתרי תוכן גדולים או כל אתר שצריך יותר יציבות, ביצועים ושליטה.</p>
        <p>לפי החבילות הקיימות, Managed WordPress Cloud מבוסס על שרתי VPS עם משאבים כמו CPU, RAM, Storage ותעבורה חודשית, למשל Core החל מ־$104.80 לחודש עם 4 shared vCPUs, 8GB RAM ו־80GB NVMe.</p>
        
        <h5 class="h6 mt-3 mb-2">מה כלול בניהול?</h5>
        <ul>
          <li>Full Management</li>
          <li>Snapshot Backup</li>
          <li>Remote Cloud Backup — 7 days</li>
          <li>Updates & Security Patches</li>
          <li>Server Monitoring</li>
          <li>Infrastructure Support</li>
          <li>Technical Consulting</li>
          <li>SSL Certificate</li>
          <li>Cyber Security System</li>
        </ul>
        <p>הרכיבים האלה מופיעים כחלק מהניהול המלא של חבילות ה־Managed VPS / WordPress Cloud.</p>

        <h5 class="h6 mt-3 mb-2">היתרון לעומת אחסון רגיל</h5>
        <ul>
          <li>הפרדה טובה יותר מלקוחות אחרים</li>
          <li>אבטחה גבוהה יותר</li>
          <li>יותר שליטה על סביבת השרת</li>
          <li>משאבים מוגדרים וברורים</li>
          <li>יכולת להגדיל CPU / RAM / Storage לפי הצורך</li>
          <li>מתאים לאתרים שצריכים יציבות וביצועים לאורך זמן</li>
        </ul>

        <h5 class="h6 mt-3 mb-2">למי זה מתאים?</h5>
        <ul>
          <li>חנויות WooCommerce</li>
          <li>אתרים עם תנועה גבוהה</li>
          <li>אתרי WordPress כבדים</li>
          <li>עסקים שהאתר קריטי לפעילות שלהם</li>
          <li>לקוחות שלא רוצים לנהל שרת לבד</li>
          <li>אתרים שצריכים אפשרות להתרחב בהמשך</li>
        </ul>

        <p><strong>במילים פשוטות</strong><br/>
        זה הפתרון למי שלא רוצה רק אחסון, אלא <strong>שרת WordPress מנוהל, מבודד, מאובטח וחזק יותר</strong>.</p>
        <div class="d-flex flex-wrap align-items-center gap-3 mt-2 mb-4">
          <a href="/he/wordpress" class="btn btn-primary">לכל חבילות Managed WordPress Cloud <i class="las la-arrow-left ms-1"></i></a>
          <span class="fs-5 fw-bold text-primary">החל מ־348.90 ₪ <span class="fs-6 text-muted fw-normal">/ לחודש</span></span>
        </div>

        <h4 class="h6 mt-4 mb-2">3. Website Care</h4>
        <p><strong>ניהול שוטף של אתר WordPress עצמו</strong></p>
        <p>Website Care הוא שירות נוסף שמיועד לעסקים שרוצים שננהל עבורם לא רק את התשתית — אלא גם את סביבת WordPress עצמה.</p>
        <p>כלומר, כאן אנחנו לא מדברים רק על שרת, אחסון או גיבויים.<br/>
        כאן מדובר על ניהול הפלטפורמה עצמה: ה־CMS של WordPress, תחזוקה שוטפת, עדכונים, בקשות, שיפורי תוכן, SEO, אופטימיזציה, טיפול במוצרים באתרי מסחר וליווי מתמשך.</p>
        <p>אפשר לראות את Website Care כתוספת שירות מעל האחסון או מעל השרת המנוהל.</p>

        <h4 class="h6 mt-4 mb-2">חבילות Website Care</h4>

        <h5 class="h6 mt-3 mb-2">Starter</h5>
        <p><strong>תחזוקה שוטפת ושקט נפשי לעסק שלך</strong></p>
        <p>מסלול Starter מתאים לעסקים שרוצים לדעת שהאתר באוויר, מאובטח, מגובה ומטופל — בלי להתעסק בצד הטכני.</p>
        <p><strong>מה כלול?</strong></p>
        <ul>
          <li>אחסון מנוהל</li>
          <li>דומיין מנוהל</li>
          <li>גיבויים יומיים</li>
          <li>ניטור שוטף</li>
          <li>תמיכה טכנית</li>
          <li>עד 2 עדכונים קטנים בחודש</li>
        </ul>
        <p><strong>מתאים ל:</strong><br/>
        עסקים שרוצים אתר יציב, מאובטח ומנוהל — בלי להתעסק בטכני.</p>

        <h5 class="h6 mt-3 mb-2">Growth</h5>
        <p><strong>אתר שמתעדכן, מתוחזק ומקודם באופן שוטף</strong><br/>
        ₪2,190 לחודש + מע״מ</p>
        <p>מסלול Growth מתאים לעסקים שלא רוצים רק “להחזיק אתר”, אלא להשתמש באתר ככלי עבודה שיווקי ועסקי.</p>
        <p>במסלול הזה אתם שולחים בקשות, ואנחנו מטפלים בהן לפי תור עבודה — עם SEO מתמשך, אופטימיזציה שוטפת ושיפור מתמשך של הנוכחות הדיגיטלית שלכם.</p>
        <p><strong>מה כלול?</strong></p>
        <ul>
          <li>בקשות ללא הגבלה — אחת בכל פעם</li>
          <li>זמן טיפול ממוצע של 48–72 שעות לכל בקשה</li>
          <li>שיווק אורגני SEO מתמשך</li>
          <li>אופטימיזציה חכמה להמרות</li>
          <li>אחסון ודומיין מנוהלים</li>
          <li>תחזוקה מלאה וגיבויים יומיים</li>
          <li>תמיכה שוטפת</li>
        </ul>
        <p><strong>מתאים ל:</strong><br/>
        עסקים שרוצים ליווי קבוע, שיפורים שוטפים וצמיחה דיגיטלית אמיתית.</p>

        <h5 class="h6 mt-3 mb-2">Commerce</h5>
        <p><strong>ניהול וצמיחה מתקדמת לאתרי מכירה</strong><br/>
        ₪3,290 לחודש + מע״מ</p>
        <p>מסלול Commerce מיועד לאתרי מכירה, חנויות אונליין ואתרי הזמנות שצריכים יותר מתחזוקה בסיסית.</p>
        <p>כשאתר הוא גם ערוץ מכירה, כל שינוי קטן יכול להשפיע על הזמנות, הכנסות וחוויית לקוח. לכן המסלול כולל ליווי שוטף, שיפור ביצועים, אופטימיזציה למכירה וניהול מקצועי יותר של סביבת האתר.</p>
        <p><strong>מה כלול?</strong></p>
        <ul>
          <li>כל מה שכלול ב־Growth</li>
          <li>התאמה לאתרי מסחר ומערכות מכירה</li>
          <li>אופטימיזציה מתקדמת לחוויית משתמש והמרות</li>
          <li>ליווי שוטף לשיפורים מסחריים באתר</li>
          <li>טיפול בעדכונים, תוספות ושיפורים בהתאם לתור העבודה</li>
          <li>תחזוקה שוטפת לסביבת אתר מורכבת יותר</li>
        </ul>
        <p><strong>העלאת מוצרים וניהול קטלוג</strong></p>
        <p>החבילה כוללת העלאה ראשונית של עד 30 מוצרים בתחילת העבודה או עם ההצטרפות.<br/>
        בהמשך כלולים עד 10 מוצרים בחודש.<br/>
        מוצרים נוספים בעלות של 29 ₪ + מע״מ למוצר פשוט, כאשר כל החומר מוכן מראש.<br/>
        מוצרים מורכבים יותר, כמו מוצרים עם וריאציות, מאפיינים מיוחדים או מידע שדורש השלמה וסידור, מתומחרים בנפרד לפי היקף העבודה.</p>
        <p><strong>מתאים ל:</strong><br/>
        חנויות אונליין, אתרי הזמנות ועסקים שמוכרים דרך האתר ורוצים ליווי רציף.</p>
        <div class="d-flex flex-wrap align-items-center gap-3 mt-2 mb-4">
          <a href="https://promo.eu.epicfinal-cloud.com/" target="_blank" rel="noopener noreferrer" class="btn btn-primary">לכל חבילות ניהול האתר ומסחר <i class="las la-arrow-left ms-1"></i></a>
          <span class="fs-5 fw-bold text-primary">החל מ־990 ₪ <span class="fs-6 text-muted fw-normal">/ לחודש</span></span>
        </div>

        <h4 class="h6 mt-4 mb-2">השוואה מהירה בין שלושת הפתרונות</h4>
        <div class="table-responsive">
          <table class="table table-bordered table-striped" style="color: #6c757d;">
            <thead>
              <tr>
                <th>נושא</th>
                <th>WordPress Hosting</th>
                <th>Managed WordPress Cloud</th>
                <th>Website Care</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>מה זה?</strong></td>
                <td>אחסון WordPress משותף</td>
                <td>שרת WordPress מנוהל</td>
                <td>ניהול שוטף של אתר WordPress עצמו</td>
              </tr>
              <tr>
                <td><strong>מה הלקוח מקבל?</strong></td>
                <td>פלטפורמה לניהול עצמי</td>
                <td>שרת מנוהל, מבודד ומאובטח יותר</td>
                <td>ניהול CMS, בקשות, תוכן, SEO ותחזוקה</td>
              </tr>
              <tr>
                <td><strong>סוג התשתית</strong></td>
                <td>אחסון משותף</td>
                <td>VPS / Cloud מנוהל</td>
                <td>שירות ניהול מעל האתר</td>
              </tr>
              <tr>
                <td><strong>האם יש עוד לקוחות על אותו שרת?</strong></td>
                <td>כן, זה אחסון משותף</td>
                <td>הפרדה גבוהה יותר מסביבה משותפת</td>
                <td>תלוי באחסון או בשרת שנבחר</td>
              </tr>
              <tr>
                <td><strong>מי מנהל את השרת?</strong></td>
                <td>EpicFinal מנהלת את סביבת האחסון הכללית</td>
                <td>EpicFinal מנהלת את השרת</td>
                <td>לא המוקד — זה ניהול האתר עצמו</td>
              </tr>
              <tr>
                <td><strong>אבטחה</strong></td>
                <td>הגנות בסיסיות לאחסון</td>
                <td>אבטחה מתקדמת יותר + Cyber Security System</td>
                <td>תחזוקה ואבטחה ברמת האתר</td>
              </tr>
              <tr>
                <td><strong>גיבויים</strong></td>
                <td>לפי חבילת האחסון</td>
                <td>Snapshot + Remote Cloud Backup ל־7 ימים</td>
                <td>גיבויים יומיים כחלק מהשירות</td>
              </tr>
              <tr>
                <td><strong>עדכוני אבטחה</strong></td>
                <td>ברמת סביבת האחסון</td>
                <td>Updates & Security Patches לשרת</td>
                <td>תחזוקה ועדכונים ברמת WordPress</td>
              </tr>
              <tr>
                <td><strong>ניטור</strong></td>
                <td>בסיסי / לפי פלטפורמה</td>
                <td>Server Monitoring</td>
                <td>ניטור שוטף לאתר</td>
              </tr>
              <tr>
                <td><strong>הגדלת משאבים</strong></td>
                <td>מוגבלת לפי חבילת אחסון</td>
                <td>כן, ניתן להגדיל משאבים לפי צורך</td>
                <td>לא רלוונטי — זה שירות ניהול</td>
              </tr>
              <tr>
                <td><strong>עדכוני תוכן</strong></td>
                <td>לא כלול</td>
                <td>לא כלול כברירת מחדל</td>
                <td>כלול לפי החבילה</td>
              </tr>
              <tr>
                <td><strong>SEO שוטף</strong></td>
                <td>לא כלול</td>
                <td>לא כלול</td>
                <td>כלול ב־Growth ומעלה</td>
              </tr>
              <tr>
                <td><strong>מתאים ל־WooCommerce</strong></td>
                <td>בסיסי / תלוי בגודל האתר</td>
                <td>כן, מתאים יותר לאתרים מסחריים</td>
                <td>Commerce מתאים לניהול שוטף של חנות</td>
              </tr>
              <tr>
                <td><strong>רמת מחיר</strong></td>
                <td>נמוכה</td>
                <td>בינונית–גבוהה</td>
                <td>שירות חודשי קבוע בשקלים</td>
              </tr>
              <tr>
                <td><strong>מתאים למי?</strong></td>
                <td>מי שמנהל לבד</td>
                <td>מי שצריך תשתית חזקה</td>
                <td>מי שרוצה שננהל לו את האתר</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h4 class="h6 mt-4 mb-2">איך לבחור?</h4>

        <h5 class="h6 mt-3 mb-2">אם אתם רוצים לנהל את האתר לבד</h5>
        <p>בחרו ב־<strong>WordPress Hosting</strong>.</p>
        <p>זה מתאים אם אתם צריכים אחסון WordPress נוח, מהיר ומאובטח, עם פלטפורמת ניהול עצמאית — ואתם או איש מקצוע מטעמכם מנהלים את האתר בפועל.</p>

        <h5 class="h6 mt-3 mb-2">אם האתר שלכם צריך יותר כוח, אבטחה והפרדה</h5>
        <p>בחרו ב־<strong>Managed WordPress Cloud</strong>.</p>
        <p>זה מתאים אם האתר חשוב לעסק, יש בו הרבה תנועה, הוא כולל חנות, או שאתם רוצים סביבת שרת מנוהלת, מאובטחת, מבודדת יותר וניתנת להרחבה.</p>

        <h5 class="h6 mt-3 mb-2">אם אתם רוצים שננהל עבורכם את האתר עצמו</h5>
        <p>בחרו ב־<strong>Website Care</strong>.</p>
        <p>זה מתאים אם אתם רוצים שננהל את סביבת WordPress עצמה: עדכונים, בקשות, תוכן, SEO, מוצרים, אופטימיזציה ותחזוקה שוטפת.</p>

        <h4 class="h6 mt-4 mb-2">ההבדל בקצרה</h4>
        <ul>
          <li><strong>WordPress Hosting</strong>: אחסון משותף עם פלטפורמה לניהול עצמי.</li>
          <li><strong>Managed WordPress Cloud</strong>: שרת WordPress מנוהל, מבודד, מאובטח וניתן להרחבה.</li>
          <li><strong>Website Care</strong>: שירות לניהול ה־CMS של WordPress, תחזוקה, תוכן, SEO ושיפורים שוטפים.</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">עדיין לא בטוחים מה מתאים לכם?</h4>
        <p>אם אתם צריכים רק מקום לאחסן בו אתר WordPress — התחילו מ־WordPress Hosting.<br/>
        אם האתר שלכם דורש יותר ביצועים, הפרדה, אבטחה או משאבים — Managed WordPress Cloud הוא הפתרון המתאים.<br/>
        אם אתם רוצים שנטפל באתר בפועל, ננהל בקשות, נבצע עדכונים, נשפר תוכן ונטפל בתחזוקה השוטפת — Website Care הוא השירות הנכון.</p>
        <p><strong>דברו איתנו ונעזור לכם לבחור את המסלול הנכון לפי סוג האתר, כמות התנועה, רמת התחזוקה והתקציב.</strong></p>
      </div>
    `
  },
  {
    id: 23,
    image: 'assets/images/blog/wordpress-popularity-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'Why Is WordPress So Popular?',
    titleHe: 'למה WordPress כל כך פופולרי?',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">למה WordPress כל כך פופולרי?</h3>
        <p>WordPress פופולרי מאוד משום שהוא משלב בין <strong>פשטות שימוש</strong>, <strong>גמישות גבוהה</strong>, ו־<strong>אקוסיסטם עצום</strong> של תבניות, תוספים, מפתחים וספקי שירות. בפועל, הוא הפך עם השנים כמעט ל־<strong>סטנדרט תעשייתי</strong> עבור אתרים מבוססי תוכן, אתרי תדמית, בלוגים, חנויות WooCommerce, פורטלים עסקיים ועוד.</p>
        <p>לפי WordPress.org, הפלטפורמה “מניעה יותר מ־43% מהרשת”, ולפי W3Techs נכון ל־15 באפריל 2026 WordPress משמשת ב־42.5% מכלל האתרים וב־59.8% מהאתרים עם מערכת ניהול תוכן מזוהה.</p>

        <h4 class="h6 mt-4 mb-2">למה זה קורה</h4>
        <p>אחת הסיבות המרכזיות לפופולריות הזו היא ש־WordPress מתאימה גם לאתרים פשוטים מאוד וגם לפרויקטים מורכבים יותר. האתר הרשמי של WordPress מציין שהיא משמשת לבניית כל דבר, מאתרים פשוטים ובלוגים ועד פורטלים מורכבים, אתרי ארגון ואפילו אפליקציות מבוססות ווב.</p>
        <p>השילוב הזה בין נגישות למתחילים לבין אפשרות להרחבה והתאמה עמוקה הוא בדיוק מה שהפך אותה לבחירה נפוצה כל כך.</p>

        <h4 class="h6 mt-4 mb-2">הכוח של האקוסיסטם</h4>
        <p>גם לאקוסיסטם הרחב יש משקל עצום. כשפלטפורמה משמשת חלק כל כך גדול מהאינטרנט, נבנים סביבה יותר תוספים, יותר תבניות, יותר מדריכים, יותר ספקי אחסון תואמים, ויותר אנשי מקצוע שיודעים לעבוד איתה.</p>
        <p>זו אחת הסיבות שבפועל WordPress נתפסת אצל עסקים רבים כמעט כמו “ברירת מחדל” או “תקן מעשי” לעולם האתרים, גם אם לא מדובר בתקן רשמי.</p>

        <h4 class="h6 mt-4 mb-2">אפקט רשת</h4>
        <p>בנוסף, הפלטפורמה נהנית מאפקט רשת חזק: ככל שיותר אתרים משתמשים בה, כך קל יותר לבחור בה גם לפרויקט הבא. יש יותר ידע, יותר הרחבות, יותר אינטגרציות, יותר ספקים שמציעים hosting ייעודי ל־WordPress, ויותר כלים מסחריים שמכוונים אליה מראש.</p>
        <p>זהו בדיוק סוג היתרון שמבדיל בין מערכת “פופולרית” לבין מערכת שהופכת בפועל לסטנדרט שוק.</p>

       

      <hr class="my-5" />

      <h3 class="h5 mb-3">Why Is WordPress So Popular?</h3>
      <p>WordPress is so popular because it combines <strong>ease of use</strong>, <strong>high flexibility</strong>, and a very large <strong>ecosystem</strong> of themes, plugins, developers, and service providers. Over time, it has become close to a <strong>de facto industry standard</strong> for content websites, business websites, blogs, WooCommerce stores, portals, and many other web projects.</p>
      <p>According to WordPress.org, WordPress powers more than 43% of the web, and according to W3Techs, as of April 15, 2026 it is used by 42.5% of all websites and 59.8% of websites with a known CMS.</p>

      <h4 class="h6 mt-4 mb-2">Why this happens</h4>
      <p>One of the main reasons for this popularity is that WordPress works well for both very simple websites and much more advanced projects. The official WordPress site says it is used for everything from simple websites and blogs to complex portals, enterprise websites, and even web applications.</p>
      <p>That combination of beginner accessibility and long-term extensibility is a major reason why it became so widely adopted.</p>

      <h4 class="h6 mt-4 mb-2">The power of the ecosystem</h4>
      <p>Its large ecosystem is another major advantage. When a platform is used by such a large portion of the web, more plugins, more themes, more tutorials, more hosting providers, and more skilled professionals grow around it.</p>
      <p>That is one reason why many businesses treat WordPress almost like a default choice or a practical standard for building websites, even though it is not a formal standard.</p>

      <h4 class="h6 mt-4 mb-2">Network effect</h4>
      <p>WordPress also benefits from a strong network effect: the more websites use it, the easier it becomes to choose it for the next project. There is more documentation, more integration support, more WordPress-specific hosting, and more third-party tooling built around it.</p>
      <p>That is what turns a platform from being merely “popular” into becoming a market standard in practice.</p>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p>WordPress is so popular because it combines ease of use, flexibility, and a massive ecosystem of plugins, themes, and professionals. In practice, it has become close to a market standard: as of April 15, 2026 it powers about 42.5% of all websites and 59.8% of websites with a known CMS, meaning a very large part of the internet already runs on it.</p>
    `
  },
  {
    id: 22,
    image: 'assets/images/blog/cpu-ram-ssd-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'For Beginners: RAM, CPU, and SSD',
    titleHe: 'למתחילים: מה זה RAM, CPU ו־SSD ואיך זה קשור לשרתים',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">למתחילים: מה זה RAM, CPU ו־SSD ואיך זה קשור לשרתים</h3>
        <p>כשמדברים על שרתים, שלושת המשאבים הבסיסיים שהכי חשוב להבין הם <strong>CPU</strong>, <strong>RAM</strong> ו־<strong>SSD</strong>. בפשטות: <strong>CPU</strong> הוא כוח העיבוד, <strong>RAM</strong> הוא זיכרון העבודה, ו־<strong>SSD</strong> הוא שטח האחסון המהיר של השרת.</p>

        <h4 class="h6 mt-4 mb-2">מה זה CPU</h4>
        <p><strong>CPU</strong> הוא המעבד של השרת. זה הרכיב שמבצע חישובים, מריץ הוראות, ומטפל בפעולות שהתוכנה מבקשת לבצע.</p>
        <p>בפועל, ככל שיש לשרת יותר כוח CPU, כך הוא יכול להתמודד טוב יותר עם:</p>
        <ul>
          <li>יותר בקשות במקביל</li>
          <li>חישובים מורכבים יותר</li>
          <li>אפליקציות כבדות יותר</li>
          <li>תהליכים כמו build, compression, parsing או backend logic</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">מה זה RAM</h4>
        <p><strong>RAM</strong> הוא זיכרון העבודה הזמני של השרת. זה המקום שבו נשמרים באופן זמני הנתונים והתוכניות שנמצאים כרגע בשימוש, כדי שהמעבד יוכל לגשת אליהם מהר.</p>
        <p>בפועל, RAM משפיע על:</p>
        <ul>
          <li>כמה תהליכים אפשר להחזיק פתוחים במקביל</li>
          <li>כמה משתמשים או חיבורים אפשר לשרת בו־זמנית</li>
          <li>כמה מקום יש למסדי נתונים, cache, PHP workers, containers או שירותים רצים</li>
        </ul>
        <p>אם חסר RAM, השרת עלול להאט מאוד או להתחיל להיכשל בעומס.</p>

        <h4 class="h6 mt-4 mb-2">מה זה SSD</h4>
        <p><strong>SSD</strong> הוא אמצעי האחסון של השרת. עליו נשמרים מערכת ההפעלה, קבצי האתר, בסיסי הנתונים, התמונות, הלוגים והקבצים האחרים.</p>
        <p>בפועל, SSD משפיע על:</p>
        <ul>
          <li>מהירות טעינת קבצים</li>
          <li>מהירות קריאה וכתיבה של נתונים</li>
          <li>זמן עליית מערכת ושירותים</li>
          <li>ביצועי מסד נתונים ואתרים שצריכים הרבה I/O</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">איך זה קשור לשרת שלך</h4>
        <p>אפשר לחשוב על זה כך:</p>
        <ul>
          <li><strong>CPU</strong> = כמה כוח יש לשרת לחשוב ולעבד</li>
          <li><strong>RAM</strong> = כמה מקום יש לשרת לעבוד כרגע</li>
          <li><strong>SSD</strong> = איפה נשמרים הקבצים והנתונים, ובאיזו מהירות אפשר לקרוא ולכתוב אותם</li>
        </ul>
        <p>לדוגמה:</p>
        <ul>
          <li>אתר עם הרבה תנועה או אפליקציה עם הרבה לוגיקה צריכים יותר <strong>CPU</strong></li>
          <li>מערכת עם הרבה משתמשים, תוספים, cache או מסד נתונים צריכה יותר <strong>RAM</strong></li>
          <li>אתר עם הרבה קבצים, מדיה או פעילות מסד נתונים נהנה מ־<strong>SSD</strong> מהיר וגדול יותר</li>
        </ul>

     

      <hr class="my-5" />

      <h3 class="h5 mb-3">For Beginners: What Are RAM, CPU, and SSD, and How Do They Relate to Servers</h3>
      <p>When people talk about servers, the three core resources you usually need to understand are <strong>CPU</strong>, <strong>RAM</strong>, and <strong>SSD</strong>. In simple terms: <strong>CPU</strong> is processing power, <strong>RAM</strong> is working memory, and <strong>SSD</strong> is the server’s fast storage.</p>

      <h4 class="h6 mt-4 mb-2">What is CPU</h4>
      <p>The <strong>CPU</strong> is the server’s processor. It performs calculations, executes instructions, and handles the operations requested by the software.</p>
      <p>In practice, more CPU power helps a server handle:</p>
      <ul>
        <li>more concurrent requests</li>
        <li>more complex calculations</li>
        <li>heavier applications</li>
        <li>processes such as builds, compression, parsing, or backend logic</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">What is RAM</h4>
      <p><strong>RAM</strong> is the server’s temporary working memory. It stores the data and software currently in use so the processor can access them quickly.</p>
      <p>In practice, RAM affects:</p>
      <ul>
        <li>how many processes can stay active at once</li>
        <li>how many users or connections can be served at the same time</li>
        <li>how much space is available for databases, cache, PHP workers, containers, or running services</li>
      </ul>
      <p>If RAM is insufficient, the server may slow down significantly or struggle under load.</p>

      <h4 class="h6 mt-4 mb-2">What is SSD</h4>
      <p>An <strong>SSD</strong> is the server’s storage device. It stores the operating system, website files, databases, images, logs, and other data.</p>
      <p>In practice, SSD affects:</p>
      <ul>
        <li>file loading speed</li>
        <li>data read and write speed</li>
        <li>system and service startup time</li>
        <li>database and website performance when storage I/O matters</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">How this relates to your server</h4>
      <p>A simple way to think about it is:</p>
      <ul>
        <li><strong>CPU</strong> = how much processing work the server can do</li>
        <li><strong>RAM</strong> = how much the server can actively keep in working memory</li>
        <li><strong>SSD</strong> = where files and data are stored, and how quickly they can be read and written</li>
      </ul>
      <p>For example:</p>
      <ul>
        <li>a high-traffic website or application with heavier logic usually needs more <strong>CPU</strong></li>
        <li>a system with many users, plugins, caches, or database activity often needs more <strong>RAM</strong></li>
        <li>a site with many files, media assets, or intensive database activity benefits from a faster and larger <strong>SSD</strong></li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>CPU</strong> is the server’s processing power, <strong>RAM</strong> is its temporary working memory, and <strong>SSD</strong> is the fast storage where files and data are kept. Together, these three resources directly affect the speed, stability, and workload capacity of your website or application.</p>
    `
  },
  {
    id: 21,
    image: 'assets/images/blog/microservices-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'What Are Microservices',
    titleHe: 'מה זה Microservices',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מה זה Microservices</h3>
        <p><strong>Microservices</strong> היא גישת ארכיטקטורה שבה לא בונים את כל המערכת כיחידה אחת גדולה, אלא מחלקים אותה לכמה <strong>שירותים קטנים, עצמאיים ונפרדים</strong>, כאשר כל שירות אחראי על יכולת עסקית מסוימת ומתקשר עם שירותים אחרים דרך API או פרוטוקולי תקשורת אחרים.</p>
        <p>במילים פשוטות: במקום מערכת אחת גדולה שמכילה הכול, אפשר לפצל למשל ל־</p>
        <ul>
          <li>שירות משתמשים</li>
          <li>שירות הזמנות</li>
          <li>שירות תשלומים</li>
          <li>שירות התראות</li>
          <li>שירות קטלוג</li>
        </ul>
        <p>כל אחד מהם יכול לרוץ כתהליך נפרד, ולעיתים גם על שרתים או קונטיינרים נפרדים.</p>

        <h4 class="h6 mt-4 mb-2">למה בכלל עושים את זה</h4>
        <ul>
          <li><strong>פריסה עצמאית</strong> של כל שירות בלי לפרוס את כל המערכת</li>
          <li><strong>סקייל נפרד</strong> לכל רכיב לפי הצורך</li>
          <li><strong>בידוד תקלות</strong> טוב יותר</li>
          <li><strong>גמישות טכנולוגית</strong> גבוהה יותר</li>
          <li><strong>תחזוקה נוחה יותר</strong> במערכות גדולות</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">מה החיסרון</h4>
        <p>Microservices לא פותרים הכול. הם בדרך כלל מוסיפים מורכבות:</p>
        <ul>
          <li>יותר שירותים לנהל</li>
          <li>יותר תקשורת פנימית בין רכיבים</li>
          <li>יותר DevOps, ניטור, לוגים ו־observability</li>
          <li>יותר אתגרי אבטחה, deployment ו־debugging</li>
          <li>צורך בתכנון טוב של APIs, data boundaries ו־service ownership</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">האם אתה צריך את זה</h4>
        <p>ברוב המקרים, <strong>לא בהתחלה</strong>.</p>
        <p>אם אתה בונה:</p>
        <ul>
          <li>אתר עסקי</li>
          <li>אתר WordPress</li>
          <li>WooCommerce</li>
          <li>מערכת פנימית קטנה</li>
          <li>SaaS קטן או MVP</li>
          <li>אפליקציה אחת עם צוות קטן</li>
        </ul>
        <p>אז בדרך כלל עדיף להתחיל עם <strong>monolith מסודר</strong> או עם אפליקציה אחת טובה, ולא עם microservices.</p>
        <p>לעומת זאת, כן יש היגיון לשקול microservices כאשר:</p>
        <ul>
          <li>המערכת כבר גדולה ומורכבת</li>
          <li>יש כמה צוותים שעובדים במקביל</li>
          <li>יש מודולים עם עומסים שונים מאוד</li>
          <li>צריך לפרוס חלקים שונים בקצב שונה</li>
          <li>יש צורך בבידוד תקלות ושירותים עצמאיים</li>
          <li>המערכת כבר סובלת ממונולית שקשה לשנות או להרחיב</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">כלל אצבע פשוט</h4>
        <p>אם אתה שואל את עצמך אם אתה צריך microservices, ברוב המקרים התשובה היא: <strong>עדיין לא.</strong></p>
        <p>עדיף להתחיל מ:</p>
        <ul>
          <li>אפליקציה אחת</li>
          <li>גבולות מודולריים טובים בתוך הקוד</li>
          <li>APIs פנימיים ברורים</li>
          <li>deployment פשוט</li>
          <li>observability בסיסי טוב</li>
        </ul>
        <p>ואז, רק אם המערכת באמת גדלה והופכת למסובכת, לפרק חלקים ספציפיים ל־microservices.</p>

      

      <hr class="my-5" />

      <h3 class="h5 mb-3">What Are Microservices</h3>
      <p><strong>Microservices</strong> is an architectural approach where a system is not built as one large unit, but instead is divided into <strong>small, independent services</strong>, with each service responsible for a specific business capability and communicating with other services through APIs or other communication protocols.</p>
      <p>In simple terms, instead of one large system that contains everything, you might split it into:</p>
      <ul>
        <li>user service</li>
        <li>orders service</li>
        <li>payments service</li>
        <li>notifications service</li>
        <li>catalog service</li>
      </ul>
      <p>Each of these can run as a separate process, and sometimes even on separate servers or containers.</p>

      <h4 class="h6 mt-4 mb-2">Why teams use this approach</h4>
      <ul>
        <li><strong>independent deployment</strong> of each service without deploying the whole system</li>
        <li><strong>separate scaling</strong> for each component</li>
        <li><strong>better fault isolation</strong></li>
        <li><strong>greater technology flexibility</strong></li>
        <li><strong>easier maintenance</strong> in larger systems</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">What is the downside</h4>
      <p>Microservices do not solve everything. They usually add complexity:</p>
      <ul>
        <li>more services to manage</li>
        <li>more internal communication between components</li>
        <li>more DevOps, monitoring, logs, and observability requirements</li>
        <li>more security, deployment, and debugging challenges</li>
        <li>a stronger need for well-defined APIs, data boundaries, and service ownership</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Do you actually need this</h4>
      <p>In most cases, <strong>not at the beginning</strong>.</p>
      <p>If you are building:</p>
      <ul>
        <li>a business website</li>
        <li>a WordPress website</li>
        <li>a WooCommerce store</li>
        <li>a small internal system</li>
        <li>a small SaaS or MVP</li>
        <li>one application with a small team</li>
      </ul>
      <p>then it is usually better to start with a <strong>well-structured monolith</strong> or a single solid application, rather than microservices.</p>
      <p>Microservices become more relevant when:</p>
      <ul>
        <li>the system is already large and complex</li>
        <li>multiple teams work in parallel</li>
        <li>different modules have very different load patterns</li>
        <li>different parts need to be deployed on different schedules</li>
        <li>stronger fault isolation is needed</li>
        <li>the existing monolith has become difficult to change or scale</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">A simple rule of thumb</h4>
      <p>If you are asking yourself whether you need microservices, in most cases the answer is: <strong>not yet</strong>.</p>
      <p>It is usually better to begin with:</p>
      <ul>
        <li>one application</li>
        <li>good modular boundaries inside the code</li>
        <li>clear internal APIs</li>
        <li>simple deployment</li>
        <li>good basic observability</li>
      </ul>
      <p>Then, only if the system truly grows and becomes difficult to manage, extract specific parts into microservices.</p>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>Microservices</strong> are an architectural model where a system is built from multiple small and independent services instead of one large application. This approach is mainly suitable for more complex systems that need higher levels of scaling, deployment flexibility, and component isolation. For smaller projects or early-stage products, it is usually better to start with one clean application and only later consider breaking parts into microservices.</p>
    `
  },
  {
    id: 20,
    image: 'assets/images/blog/ports-reverse-proxy-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'Opening Ports vs Using a Reverse Proxy',
    titleHe: 'מה זאת אומרת פתיחת פורטים, ומתי עדיף להשתמש ב־Reverse Proxy',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מה זאת אומרת פתיחת פורטים, ומתי עדיף להשתמש ב־Reverse Proxy</h3>
        <p><strong>פתיחת פורטים</strong> פירושה לאפשר לתעבורה חיצונית להגיע לשירות מסוים בשרת דרך מספר פורט מוגדר. פורט הוא נקודת קצה לוגית של חיבור רשת, וכל שירות מאזין בדרך כלל על פורט משלו. לדוגמה, אתר אינטרנט נחשף בדרך כלל דרך <code>80</code> או <code>443</code>, בעוד שירות אחר יכול לעבוד על פורט אחר לגמרי.</p>
        <p>בפועל, “לפתוח פורט” אומר להגדיר את שכבת הרשת או חומת האש כך שבקשות מבחוץ יורשו להגיע לאותו שירות. לדוגמה, אם אפליקציה מאזינה על פורט <code>3000</code>, היא לא תהיה נגישה מהאינטרנט עד שתהיה הרשאה מתאימה ב־firewall, ב־security group, או בשכבת הרשת הרלוונטית.</p>

        <h4 class="h6 mt-4 mb-2">מתי פותחים פורט ישירות</h4>
        <p>פתיחת פורט ישירות מתאימה כשבאמת צריך לחשוף שירות מסוים כמו:</p>
        <ul>
          <li>אתר HTTP/HTTPS</li>
          <li>SSH לניהול</li>
          <li>API ייעודי</li>
          <li>שירות פנימי שצריך להיות נגיש מכתובות מוגבלות</li>
        </ul>
        <p>אבל עדיף לפתוח רק את מה שבאמת צריך, ורק למקורות הנכונים.</p>

        <h4 class="h6 mt-4 mb-2">מה זה Reverse Proxy</h4>
        <p><strong>Reverse Proxy</strong> הוא שרת שמקבל את הבקשות מהלקוח, ואז מעביר אותן לשרת פנימי או לשירות אחר מאחורי הקלעים. כלומר, המשתמש פונה לכתובת אחת, אבל בפועל ה־proxy מחליט לאיזה שירות פנימי לשלוח את הבקשה.</p>
        <p>בדרך כלל, reverse proxy יושב על הפורטים הציבוריים <code>80</code> ו־<code>443</code>, ומנתב את הבקשות לשירותים פנימיים שרצים על פורטים כמו <code>3000</code>, <code>5000</code>, <code>8080</code> או אפילו על שרתים אחרים ברשת פנימית. כך אפשר להחזיק כמה אפליקציות מאחורי כניסה ציבורית אחת, בלי לחשוף כל פורט פנימי ישירות לאינטרנט.</p>

        <h4 class="h6 mt-4 mb-2">מתי עדיף להשתמש ב־Reverse Proxy</h4>
        <ul>
          <li>כשרוצים לחשוף כמה שירותים דרך דומיין אחד או כמה subdomains</li>
          <li>כשרוצים לשמור שירותים פנימיים לא חשופים ישירות</li>
          <li>כשרוצים לנהל SSL במקום אחד</li>
          <li>כשרוצים להוסיף שכבת routing, caching, headers או auth</li>
          <li>כשרוצים להחליף backend בעתיד בלי לשנות את הכתובת הציבורית</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">מתי עדיף לא לפתוח הרבה פורטים</h4>
        <p>אם יש לכם כמה אפליקציות על אותו שרת או על כמה שרתים, לרוב עדיף <strong>לא</strong> לפתוח לכל אחת פורט ציבורי נפרד. במקום זה, עדיף לפתוח רק <code>80/443</code> ולהשתמש ב־reverse proxy. זה בדרך כלל נותן:</p>
        <ul>
          <li>פחות שטח תקיפה</li>
          <li>יותר סדר בניהול DNS ו־SSL</li>
          <li>פחות תלות בפורטים לא סטנדרטיים</li>
          <li>חוויית משתמש טובה יותר</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">מתי כן לפתוח פורט ישיר</h4>
        <p>פתיחת פורט ישיר עדיין הגיונית כאשר:</p>
        <ul>
          <li>מדובר בשירות שאינו HTTP/HTTPS</li>
          <li>צריך גישת SSH או RDP</li>
          <li>יש שירות ייעודי ש־reverse proxy לא מתאים לו</li>
          <li>הגישה מוגבלת רק ל־IPים ידועים או ל־VPN</li>
          <li>מדובר בסביבת פיתוח או תשתית פנימית מבוקרת</li>
        </ul>

    

      <hr class="my-5" />

      <h3 class="h5 mb-3">What does opening ports mean, and when is it better to use a reverse proxy</h3>
      <p><strong>Opening ports</strong> means allowing external traffic to reach a specific service on a server through a defined port number. A port is a logical network endpoint, and each service usually listens on its own port. For example, a website is commonly exposed on <code>80</code> or <code>443</code>, while another application may run on a completely different port.</p>
      <p>In practice, “opening a port” means configuring the network layer, firewall, or security controls so external requests are allowed to reach that service. For example, if an application listens on port <code>3000</code>, it will not be reachable from the internet unless the relevant firewall, security group, or network policy explicitly allows that inbound traffic.</p>

      <h4 class="h6 mt-4 mb-2">When to open a port directly</h4>
      <p>Opening a port directly makes sense when you truly need to expose a specific service such as:</p>
      <ul>
        <li>a website over HTTP/HTTPS</li>
        <li>SSH for administration</li>
        <li>a dedicated API</li>
        <li>an internal service that must be reachable from restricted sources</li>
      </ul>
      <p>Even then, it is best to open only what is necessary, and only to the correct sources.</p>

      <h4 class="h6 mt-4 mb-2">What is a reverse proxy</h4>
      <p>A <strong>reverse proxy</strong> is a server that receives client requests and then forwards them to an internal server or backend service. In other words, the visitor connects to one public entry point, while the proxy decides which internal service should handle the request.</p>
      <p>A reverse proxy usually listens on public ports such as <code>80</code> and <code>443</code> and then routes requests to internal services running on ports like <code>3000</code>, <code>5000</code>, <code>8080</code>, or even to separate backend servers inside a private network. This makes it possible to run multiple applications behind a single public entry point without exposing every internal port directly to the internet.</p>

      <h4 class="h6 mt-4 mb-2">When a reverse proxy is the better choice</h4>
      <ul>
        <li>you want to expose multiple services through one domain or several subdomains</li>
        <li>you want internal services to stay hidden from direct public access</li>
        <li>you want to manage SSL in one place</li>
        <li>you want routing, caching, headers, or auth at a central layer</li>
        <li>you want to change backends later without changing the public address</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">When it is better not to open many ports</h4>
      <p>If you run several applications on one server or across multiple servers, it is often better <strong>not</strong> to expose a separate public port for each one. Instead, it is usually cleaner to expose only <code>80/443</code> and place a reverse proxy in front. This typically gives you:</p>
      <ul>
        <li>a smaller attack surface</li>
        <li>simpler DNS and SSL management</li>
        <li>less reliance on non-standard ports</li>
        <li>a cleaner user experience</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">When direct port exposure still makes sense</h4>
      <p>Opening a port directly can still be the right choice when:</p>
      <ul>
        <li>the service is not HTTP/HTTPS</li>
        <li>you need SSH or RDP access</li>
        <li>the service does not fit well behind a reverse proxy</li>
        <li>access is restricted to known IPs or VPN users</li>
        <li>the service is part of a controlled internal or development environment</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>Opening ports</strong> means allowing external access to a specific server service through a defined port such as <code>80</code>, <code>443</code>, or <code>22</code>. A <strong>reverse proxy</strong> is a server that receives public requests and forwards them to internal services, making it the better choice when you want to expose multiple applications in a cleaner, safer, and more manageable way. In practice, unless there is a specific reason not to, it is usually better to expose only <code>80/443</code> and use a reverse proxy instead of opening many different public ports directly to the internet.</p>
    `
  },
  {
    id: 19,
    image: 'assets/images/blog/mail-server-vps-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'What Is a Mail Server and How It Relates to Your VPS',
    titleHe: 'מה זה שרת מייל ואיך הוא קשור למכונה הווירטואלית שלך',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מה זה שרת מייל ואיך הוא קשור למכונה הווירטואלית שלך</h3>
        <p><strong>שרת מייל</strong> הוא השירות שמקבל, שולח ומאחסן דואר אלקטרוני עבור הדומיין שלך. בפועל יש לפחות שני חלקים עיקריים: שרת שמעביר דואר יוצא ונכנס ב־<strong>SMTP</strong>, ושרת שמאפשר למשתמשים לגשת לתיבות הדואר דרך פרוטוקולים כמו <strong>IMAP</strong> או <strong>POP</strong>.</p>

        <h4 class="h6 mt-4 mb-2">איך זה קשור ל־VPS שלך</h4>
        <p>המכונה הווירטואלית שלך יכולה <strong>לשמש כשרת מייל</strong>, אבל זה לא קורה אוטומטית. VPS הוא רק השרת או מערכת ההפעלה שעליה אפשר להתקין ולהגדיר שירותי מייל. כדי שזה באמת יעבוד, צריך להקים ולהגדיר את שירותי הדואר, לפתוח ולהקשיח את ההגדרות הנדרשות, ולעדכן את ה־DNS של הדומיין כך שיפנה לשרת הנכון.</p>

        <h4 class="h6 mt-4 mb-2">חשוב: שרת מייל לא “נוצר לבד”</h4>
        <p>אם קנית VPS, זה <strong>לא אומר</strong> שיש לך דואר עסקי מוכן. כדי שהדומיין שלך באמת יוכל לקבל ולשלוח דוא״ל, צריך לפחות:</p>
        <ul>
          <li>שרת מייל או ספק מייל פעיל</li>
          <li>רשומת <strong>MX</strong> שמפנה ליעד הנכון</li>
          <li>בדרך כלל גם רשומות כמו <strong>A/AAAA</strong> עבור <code>mail.yourdomain.com</code></li>
          <li>ולעיתים גם הגדרות נוספות הקשורות לאימות ושליחה תקינה של מיילים</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">מה יש בדרך כלל בשתי האפשרויות</h4>

        <h5 class="h6 mt-3 mb-2">1. להקים שרת מייל על ה־VPS שלך</h5>
        <p>זה אומר שאתה או איש סיסטם מטעמך מקימים ומנהלים את כל סביבת הדוא״ל. בדרך כלל זה כולל:</p>
        <ul>
          <li>התקנת שירותי SMTP/IMAP/POP</li>
          <li>יצירת תיבות דואר</li>
          <li>הגדרת <strong>MX</strong></li>
          <li>הגדרת <strong>A/AAAA</strong> או <code>mail.domain.com</code></li>
          <li>ניהול אבטחה, TLS, עדכונים, ניטור, גיבויים וסינון ספאם</li>
        </ul>

        <h5 class="h6 mt-3 mb-2">2. לרכוש שירות מייל מצד שלישי</h5>
        <p>במקום להרים שרת דואר בעצמך, אפשר להשתמש בשירות כמו Microsoft 365, Google Workspace או ספק מייל אחר. במקרה כזה ה־VPS שלך <strong>לא חייב</strong> להריץ שרת מייל בכלל; אתה רק מפנה את ה־MX של הדומיין אל ספק המייל.</p>

        <h4 class="h6 mt-4 mb-2">מתי עדיף לקחת שירות צד ג'</h4>
        <p>אם אין לך ידע טוב בניהול שרתים, DNS, אבטחת דוא״ל, טיפול בספאם, מסירה נכונה של הודעות ותחזוקת מערכת, בדרך כלל <strong>עדיף לקחת שירות צד ג'</strong>. דוא״ל הוא שירות רגיש, ותפעול שגוי עלול לגרום לבעיות מסירה, דואר שמסווג כספאם, נפילות תיבה או חשיפה אבטחתית.</p>

        <h4 class="h6 mt-4 mb-2">מתי כן הגיוני להרים שרת מייל על ה־VPS</h4>
        <p>זה רלוונטי בעיקר אם:</p>
        <ul>
          <li>יש לך ידע בניהול Linux או Windows Server ומערכות מייל</li>
          <li>יש דרישות מיוחדות של שליטה מלאה</li>
          <li>יש צורך פנימי, ארגוני או רגולטורי מסוים</li>
          <li>אתה מוכן לנהל עדכונים, גיבויים, ניטור, אנטי־ספאם ו־DNS בעצמך</li>
        </ul>

      

      <hr class="my-5" />

      <h3 class="h5 mb-3">What Is a Mail Server and How It Relates to Your VPS</h3>
      <p>A <strong>mail server</strong> is the service responsible for receiving, sending, and storing email for your domain. In practice, there are at least two main parts: a server that handles incoming and outgoing mail over <strong>SMTP</strong>, and a server that allows users to access their mailboxes through protocols such as <strong>IMAP</strong> or <strong>POP</strong>.</p>

      <h4 class="h6 mt-4 mb-2">How this relates to your VPS</h4>
      <p>Your virtual machine can <strong>act as a mail server</strong>, but that does not happen automatically. A VPS is only the server or operating system on which mail services can be installed and configured. For this to actually work, you need to set up the mail services, open and harden the required settings, and update the domain’s DNS so it points to the correct server.</p>

      <h4 class="h6 mt-4 mb-2">Important: a mail server does not appear automatically</h4>
      <p>If you bought a VPS, that <strong>does not mean</strong> you automatically have business email ready to use. For your domain to really send and receive email, you usually need at least:</p>
      <ul>
        <li>an active mail server or mail provider</li>
        <li>an <strong>MX</strong> record pointing to the correct destination</li>
        <li>usually also <strong>A/AAAA</strong> records for <code>mail.yourdomain.com</code></li>
        <li>and sometimes additional settings related to authentication and reliable mail delivery</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">The two common approaches</h4>

      <h5 class="h6 mt-3 mb-2">1. Run a mail server on your VPS</h5>
      <p>This means you or your system administrator sets up and manages the full email environment. That usually includes:</p>
      <ul>
        <li>installing SMTP/IMAP/POP services</li>
        <li>creating mailboxes</li>
        <li>configuring <strong>MX</strong></li>
        <li>configuring <strong>A/AAAA</strong> or <code>mail.domain.com</code></li>
        <li>managing security, TLS, updates, monitoring, backups, and spam filtering</li>
      </ul>

      <h5 class="h6 mt-3 mb-2">2. Buy mail as a third-party service</h5>
      <p>Instead of building your own mail server, you can use a service such as Microsoft 365, Google Workspace, or another mail provider. In that case, your VPS <strong>does not need</strong> to run a mail server at all; you simply point the domain’s MX record to that provider.</p>

      <h4 class="h6 mt-4 mb-2">When a third-party service is usually better</h4>
      <p>If you do not have solid knowledge of server management, DNS, email security, spam handling, deliverability, and ongoing system maintenance, it is usually <strong>better to use a third-party mail service</strong>. Email is a sensitive service, and incorrect setup can lead to delivery problems, messages being marked as spam, mailbox outages, or security exposure.</p>

      <h4 class="h6 mt-4 mb-2">When it makes sense to run mail on the VPS</h4>
      <p>This is usually relevant if:</p>
      <ul>
        <li>you have experience managing Linux or Windows Server and mail systems</li>
        <li>you have special requirements for full control</li>
        <li>there is a specific internal, organizational, or regulatory need</li>
        <li>you are prepared to handle updates, backups, monitoring, anti-spam, and DNS yourself</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>A mail server</strong> is the system responsible for sending, receiving, and storing email for your domain. Your VPS can be used as a mail server, but that <strong>does not happen automatically</strong> — you must set up the mail services and the required DNS records, or use a third-party mail provider instead. If you do not have experience managing mail servers, a managed external service is usually the safer choice.</p>
    `
  },
  {
    id: 18,
    image: 'assets/images/blog/shared-to-vps-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'When Should a Website Move from Shared Hosting to VPS',
    titleHe: 'מתי אתר צריך לעבור מאחסון שיתופי ל־VPS',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מתי אתר צריך לעבור מאחסון שיתופי ל־VPS</h3>
        <p>המעבר מאחסון שיתופי ל־VPS נדרש בדרך כלל כאשר האתר מתחיל לחרוג מהגבולות הטבעיים של סביבת shared hosting, בין אם מבחינת ביצועים, שליטה, אבטחה או דרישות טכניות.</p>

        <h4 class="h6 mt-4 mb-2">סימנים נפוצים שהגיע הזמן לעבור ל־VPS</h4>

        <h5 class="h6 mt-3 mb-2">1. האתר נהיה איטי או לא יציב</h5>
        <p>אם זמני הטעינה מתחילים לעלות, אם יש האטות בשעות עומס, או אם מופיעות נפילות לסירוגין, ייתכן שהאתר כבר מושפע ממגבלות של אחסון שיתופי.</p>

        <h5 class="h6 mt-3 mb-2">2. יש גידול קבוע בתנועה</h5>
        <p>כאשר האתר כבר לא קטן, ויש גידול יציב בכמות המבקרים או בפעילות באתר, סביר שתידרש סביבת hosting עם משאבים עקביים יותר.</p>

        <h5 class="h6 mt-3 mb-2">3. צריך יותר שליטה טכנית</h5>
        <p>אם אתם צריכים להתקין תוכנות מותאמות, לשנות הגדרות שרת, להשתמש בגישת root, להגדיר firewall משלכם, להריץ תהליכים מיוחדים, Docker, workers, cron jobs מתקדמים או אינטגרציות מותאמות, shared hosting בדרך כלל לא יספיק.</p>

        <h5 class="h6 mt-3 mb-2">4. האתר או האפליקציה הפכו מורכבים יותר</h5>
        <p>חנויות אונליין, מערכות SaaS, אתרי membership, APIs, פורטלים, או כמה שירותים שרצים יחד, כל אלה נוטים לדרוש יותר משאבים, יותר בידוד ויותר שליטה.</p>

        <h5 class="h6 mt-3 mb-2">5. צריך ביצועים עקביים יותר</h5>
        <p>באחסון שיתופי אתם חולקים CPU, RAM ו־storage עם אתרים נוספים. כאשר אתם צריכים ביצועים יותר צפויים ויציבים, VPS הוא בדרך כלל צעד הגיוני.</p>

        <h5 class="h6 mt-3 mb-2">6. דרישות האבטחה עלו</h5>
        <p>אם צריך שכבות אבטחה מותאמות, hardening ברמת מערכת, או בקרה עמוקה יותר על סביבת ההפעלה, VPS נותן יותר יכולת פעולה מאשר shared hosting.</p>

        <h4 class="h6 mt-4 mb-2">מתי עדיין לא חייבים VPS</h4>
        <p>לא כל אתר צריך לעבור מיד. אם מדובר באתר תדמית קטן, בלוג פשוט, או אתר עסקי בסיסי עם תנועה נמוכה ובלי דרישות טכניות מיוחדות, אחסון שיתופי עדיין יכול להיות פתרון נכון.</p>

        <h4 class="h6 mt-4 mb-2">כלל אצבע פשוט</h4>
        <ul>
          <li>האתר כבר לא יציב או לא מהיר מספיק</li>
          <li>יש גידול קבוע בתנועה</li>
          <li>יש צורך בגישה עמוקה יותר לשרת</li>
          <li>יש צורך בתוכנות, קונפיגורציות או אבטחה מותאמות</li>
          <li>האתר הפך למערכת מורכבת יותר ולא רק “אתר בסיסי”</li>
        </ul>

        

      <hr class="my-5" />

      <h3 class="h5 mb-3">When should a website move from shared hosting to VPS</h3>
      <p>A website usually needs to move from shared hosting to VPS when it starts to outgrow the natural limits of a shared environment, whether in terms of performance, control, security, or technical requirements.</p>

      <h4 class="h6 mt-4 mb-2">Common signs it is time to move to VPS</h4>

      <h5 class="h6 mt-3 mb-2">1. The website becomes slow or unstable</h5>
      <p>If page load times are getting worse, if the site slows down during busy hours, or if there are recurring outages, the site may already be hitting the limits of shared hosting.</p>

      <h5 class="h6 mt-3 mb-2">2. Traffic is growing steadily</h5>
      <p>When a website is no longer small and traffic is increasing consistently, it often needs a hosting environment with more predictable resources.</p>

      <h5 class="h6 mt-3 mb-2">3. More technical control is needed</h5>
      <p>If you need to install custom software, change server settings, use root access, configure your own firewall, run custom processes, Docker, advanced cron jobs, workers, or deeper integrations, shared hosting is usually no longer enough.</p>

      <h5 class="h6 mt-3 mb-2">4. The website or application has become more complex</h5>
      <p>Online stores, SaaS platforms, membership websites, APIs, portals, or multiple services running together often require more resources, more isolation, and more control.</p>

      <h5 class="h6 mt-3 mb-2">5. More consistent performance is required</h5>
      <p>In shared hosting, CPU, RAM, and storage are shared with other customers. When predictable performance becomes important, VPS is usually the logical next step.</p>

      <h5 class="h6 mt-3 mb-2">6. Security requirements are higher</h5>
      <p>If the project requires stronger hardening, custom security controls, or deeper operating-system-level oversight, VPS gives more flexibility than shared hosting.</p>

      <h4 class="h6 mt-4 mb-2">When shared hosting may still be enough</h4>
      <p>Not every website needs VPS right away. If the site is a small brochure website, a simple blog, or a basic business website with modest traffic and no unusual technical needs, shared hosting can still be the right choice.</p>

      <h4 class="h6 mt-4 mb-2">A simple rule of thumb</h4>
      <ul>
        <li>the website is no longer fast or stable enough</li>
        <li>traffic is growing consistently</li>
        <li>deeper server-level access is needed</li>
        <li>custom software, configuration, or security is required</li>
        <li>the project has become more than just a basic website</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p>A website usually needs to move from shared hosting to VPS when it starts requiring more performance, stability, control, and security than a shared environment can provide. Common signs include slower performance, steady traffic growth, the need for real server-level access, or a move toward a more complex website, store, system, or web application.</p>
    `
  },
  {
    id: 17,
    image: 'assets/images/blog/website-vs-webapp-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'Website vs Web Application',
    titleHe: 'מה ההבדל בין אתר אינטרנט לאפליקציית ווב',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מה ההבדל בין אתר אינטרנט לאפליקציית ווב</h3>
        <p><strong>אתר אינטרנט</strong> הוא בדרך כלל אוסף של דפי ווב שמוגשים מאותו דומיין ומטרתם העיקרית היא להציג מידע, תוכן, עמודי שירות, בלוג, קטלוג, דפי נחיתה וכדומה.</p>
        <p><strong>אפליקציית ווב</strong> היא תוכנה שרצה בדפדפן ומאפשרת למשתמש לבצע פעולות, לעבוד עם נתונים, לנהל תהליכים או להשתמש בפונקציונליות עסקית.</p>

        <h4 class="h6 mt-4 mb-2">ההבדל בפשטות</h4>
        <ul>
          <li><strong>אתר אינטרנט</strong> נועד בעיקר להציג מידע</li>
          <li><strong>אפליקציית ווב</strong> נועדה בעיקר לאפשר פעולה ושימוש אינטראקטיבי</li>
        </ul>
        <p>לכן, אתר תדמית, עמוד חברה או בלוג הם בדרך כלל אתרים. לעומת זאת, מערכת ניהול, פורטל לקוחות, מערכת הזמנות, CRM, SaaS או אזור משתמש עם לוגיקה עסקית הם בדרך כלל אפליקציות ווב.</p>

        <h4 class="h6 mt-4 mb-2">דוגמאות</h4>
        <p><strong>אתר אינטרנט:</strong></p>
        <ul>
          <li>אתר חברה</li>
          <li>בלוג</li>
          <li>אתר חדשות</li>
          <li>עמוד נחיתה</li>
          <li>אתר תדמית</li>
        </ul>
        <p><strong>אפליקציית ווב:</strong></p>
        <ul>
          <li>מערכת CRM</li>
          <li>פורטל לקוחות</li>
          <li>מערכת ניהול משימות</li>
          <li>מערכת הנהלת חשבונות בדפדפן</li>
          <li>חנות עם לוגיקה מתקדמת, משתמשים, הזמנות ותהליכים</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">האם אתר יכול לכלול גם אפליקציית ווב</h4>
        <p>כן. בפועל, הרבה פעמים יש חפיפה. אתר שיווקי יכול לכלול גם אזור התחברות, טפסים חכמים, פורטל לקוחות או חנות. במקרה כזה, החלק הציבורי הוא יותר “אתר”, והחלק האינטראקטיבי הוא יותר “אפליקציית ווב”.</p>


      <hr class="my-5" />

      <h3 class="h5 mb-3">What is the difference between a website and a web application</h3>
      <p>A <strong>website</strong> is usually a collection of web pages served from the same domain, mainly intended to present information, content, service pages, blogs, catalogs, landing pages, and similar material.</p>
      <p>A <strong>web application</strong> is software that runs in the browser and allows users to perform actions, work with data, manage processes, or use business functionality.</p>

      <h4 class="h6 mt-4 mb-2">The simple difference</h4>
      <ul>
        <li><strong>a website</strong> is mainly built to present information</li>
        <li><strong>a web application</strong> is mainly built to enable action and interactive use</li>
      </ul>
      <p>That means a company website, brochure site, or blog is usually a website, while an admin system, customer portal, booking system, CRM, SaaS platform, or user area with business logic is usually a web application.</p>

      <h4 class="h6 mt-4 mb-2">Examples</h4>
      <p><strong>Website:</strong></p>
      <ul>
        <li>company website</li>
        <li>blog</li>
        <li>news website</li>
        <li>landing page</li>
        <li>brochure website</li>
      </ul>
      <p><strong>Web application:</strong></p>
      <ul>
        <li>CRM system</li>
        <li>customer portal</li>
        <li>task management system</li>
        <li>browser-based accounting system</li>
        <li>store with advanced logic, users, orders, and workflows</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Can a website also include a web application</h4>
      <p>Yes. In practice, there is often overlap. A marketing website can also include login areas, smart forms, a customer portal, or a store. In that case, the public-facing part is more of a website, while the interactive part behaves more like a web application.</p>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>A website</strong> is mainly intended to present information, content, and service pages. <strong>A web application</strong> is a browser-based system that allows users to perform actions, work with data, and use business functionality. In practice, many modern websites combine both.</p>
    `
  },
  {
    id: 16,
    image: 'assets/images/blog/subdomains-servers-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'How to Connect Multiple Servers Under Different Subdomains',
    titleHe: 'איך לחבר כמה שרתים תחת Subdomains שונים',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מדריך: איך לחבר כמה שרתים תחת Subdomains שונים</h3>
        <p>בתרחיש הזה לא מחברים כמה שרתים לאותו hostname, אלא מגדירים <strong>תת־דומיין נפרד לכל שרת או שירות</strong>.</p>
        <ul>
          <li><code>app.example.com</code> → שרת אפליקציה</li>
          <li><code>api.example.com</code> → שרת API</li>
          <li><code>shop.example.com</code> → שרת חנות</li>
          <li><code>panel.example.com</code> → שרת ניהול</li>
        </ul>
        <p>ב־DNS, תת־דומיין נוצר בדרך כלל על ידי הוספת רשומת <strong>A</strong>, <strong>AAAA</strong> או <strong>CNAME</strong> עבור אותו hostname.</p>

        <h4 class="h6 mt-4 mb-2">איך זה עובד</h4>
        <p>הדומיין הראשי שלך יכול להיות למשל:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>example.com</code>
        </div>
        <p>ולכל שרת או שירות יוצרים תת־דומיין משלו:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>app.example.com</code><br />
          <code>api.example.com</code><br />
          <code>shop.example.com</code><br />
          <code>mail.example.com</code>
        </div>
        <p>כל תת־דומיין מקבל רשומת DNS נפרדת, שמצביעה לכתובת ה־IP של השרת המתאים, או ליעד אחר דרך CNAME.</p>

        <h4 class="h6 mt-4 mb-2">מתי משתמשים ב־A record ומתי ב־CNAME</h4>
        <ul>
          <li>משתמשים ב־<strong>A record</strong> כאשר רוצים שתת־הדומיין יפנה ישירות לכתובת IPv4 של שרת</li>
          <li>משתמשים ב־<strong>AAAA record</strong> כאשר רוצים להפנות ל־IPv6</li>
          <li>משתמשים ב־<strong>CNAME</strong> כאשר רוצים שתת־הדומיין יפנה לשם מארח אחר במקום ל־IP ישיר</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">דוגמה פשוטה</h4>
        <p>אם יש לך שלושה שרתים:</p>
        <ul>
          <li><code>203.0.113.10</code> עבור האתר הראשי</li>
          <li><code>203.0.113.20</code> עבור API</li>
          <li><code>203.0.113.30</code> עבור פאנל ניהול</li>
        </ul>
        <p>רשומות ה־DNS יכולות להיראות כך:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>app&nbsp;&nbsp;&nbsp;&nbsp;A&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;203.0.113.10</code><br />
          <code>api&nbsp;&nbsp;&nbsp;&nbsp;A&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;203.0.113.20</code><br />
          <code>panel&nbsp;&nbsp;A&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;203.0.113.30</code>
        </div>
        <p>התוצאה תהיה:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>app.example.com</code><br />
          <code>api.example.com</code><br />
          <code>panel.example.com</code>
        </div>

        <h4 class="h6 mt-4 mb-2">שלבים מעשיים</h4>
        <h5 class="h6 mt-3 mb-2">1. בוחרים תת־דומיין לכל שירות</h5>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>web.example.com</code><br />
          <code>api.example.com</code><br />
          <code>admin.example.com</code>
        </div>

        <h5 class="h6 mt-3 mb-2">2. פותחים את אזור ה־DNS של הדומיין</h5>
        <p>נכנסים לספק ה־DNS שלך, למשל Cloudflare, registrar, או DNS provider אחר.</p>

        <h5 class="h6 mt-3 mb-2">3. מוסיפים רשומת DNS לכל תת־דומיין</h5>
        <p>למשל ב־Cloudflare:</p>
        <ul>
          <li>נכנסים ל־<strong>DNS</strong></li>
          <li>לוחצים <strong>Add record</strong></li>
          <li>בוחרים <strong>A</strong>, <strong>AAAA</strong> או <strong>CNAME</strong></li>
          <li>בשדה <strong>Name</strong> כותבים את תת־הדומיין, למשל <code>api</code></li>
          <li>בשדה <strong>Content / Value</strong> כותבים את ה־IP או hostname של השרת</li>
          <li>שומרים</li>
        </ul>

        <h5 class="h6 mt-3 mb-2">4. מוודאים שהשרת עצמו מוכן לאותו hostname</h5>
        <p>בשרת צריך להיות מוגדר שהשירות מקבל בקשות עבור אותו hostname.</p>
        <ul>
          <li>ב־NGINX: <code>server_name api.example.com;</code></li>
          <li>באפליקציה: domain או base URL נכון</li>
          <li>ב־SSL: תעודה שמתאימה ל־subdomain</li>
        </ul>

        <h5 class="h6 mt-3 mb-2">5. מגדירים SSL לכל תת־דומיין</h5>
        <p>אם כל שירות נחשף תחת subdomain אחר, צריך לדאוג שלכל אחד יהיה HTTPS תקין.</p>

        <h4 class="h6 mt-4 mb-2">מתי זה עדיף</h4>
        <ul>
          <li>כשיש כמה שירותים נפרדים</li>
          <li>כשיש כמה שרתים עם תפקידים שונים</li>
          <li>כשצריך הפרדה ברורה בין אתר, API, פאנל, דואר או מערכות פנימיות</li>
          <li>כשרוצים ארכיטקטורה נקייה ופשוטה לניהול</li>
        </ul>
        <p>לדוגמה:</p>
        <ul>
          <li><code>www.example.com</code> → אתר שיווקי</li>
          <li><code>app.example.com</code> → אפליקציה</li>
          <li><code>api.example.com</code> → API</li>
          <li><code>status.example.com</code> → סטטוס</li>
          <li><code>mail.example.com</code> → שירות דואר</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">אם רוצים ניהול DNS נפרד לתת־דומיין</h4>
        <p>במקרים מתקדמים אפשר גם להאציל subdomain לאזור DNS נפרד באמצעות <strong>NS records</strong>. זה לא נדרש ברוב המקרים, אבל כן שימושי אם רוצים שניהול <code>api.example.com</code> יהיה נפרד מניהול <code>example.com</code>.</p>

    

      <hr class="my-5" />

      <h3 class="h5 mb-3">Guide: how to connect multiple servers under different subdomains</h3>
      <p>In this setup, you do not connect multiple servers to the same hostname. Instead, you assign a <strong>separate subdomain to each server or service</strong>.</p>
      <ul>
        <li><code>app.example.com</code> → application server</li>
        <li><code>api.example.com</code> → API server</li>
        <li><code>shop.example.com</code> → store server</li>
        <li><code>panel.example.com</code> → management server</li>
      </ul>
      <p>In DNS, a subdomain is usually created by adding an <strong>A</strong>, <strong>AAAA</strong>, or <strong>CNAME</strong> record for that specific hostname.</p>

      <h4 class="h6 mt-4 mb-2">How it works</h4>
      <p>Your main domain might be:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>example.com</code>
      </div>
      <p>You then create a dedicated subdomain for each server:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>app.example.com</code><br />
        <code>api.example.com</code><br />
        <code>shop.example.com</code><br />
        <code>mail.example.com</code>
      </div>
      <p>Each subdomain gets its own DNS record, pointing either to the IP address of the correct server or to another hostname through CNAME.</p>

      <h4 class="h6 mt-4 mb-2">When to use an A record vs CNAME</h4>
      <ul>
        <li>use an <strong>A record</strong> when the subdomain should point directly to an IPv4 address</li>
        <li>use an <strong>AAAA record</strong> when the subdomain should point to an IPv6 address</li>
        <li>use a <strong>CNAME</strong> when the subdomain should point to another hostname instead of a direct IP</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Simple example</h4>
      <p>If you have three servers:</p>
      <ul>
        <li><code>203.0.113.10</code> for the main application</li>
        <li><code>203.0.113.20</code> for the API</li>
        <li><code>203.0.113.30</code> for the admin panel</li>
      </ul>
      <p>Your DNS zone could look like this:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>app&nbsp;&nbsp;&nbsp;&nbsp;A&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;203.0.113.10</code><br />
        <code>api&nbsp;&nbsp;&nbsp;&nbsp;A&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;203.0.113.20</code><br />
        <code>panel&nbsp;&nbsp;A&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;203.0.113.30</code>
      </div>
      <p>The result would be:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>app.example.com</code><br />
        <code>api.example.com</code><br />
        <code>panel.example.com</code>
      </div>

      <h4 class="h6 mt-4 mb-2">Practical steps</h4>
      <h5 class="h6 mt-3 mb-2">1. Choose one subdomain per service</h5>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>web.example.com</code><br />
        <code>api.example.com</code><br />
        <code>admin.example.com</code>
      </div>

      <h5 class="h6 mt-3 mb-2">2. Open the domain’s DNS zone</h5>
      <p>Log in to your DNS provider, such as Cloudflare, your registrar, or another DNS management platform.</p>

      <h5 class="h6 mt-3 mb-2">3. Add a DNS record for each subdomain</h5>
      <p>For example in Cloudflare:</p>
      <ul>
        <li>open <strong>DNS</strong></li>
        <li>click <strong>Add record</strong></li>
        <li>choose <strong>A</strong>, <strong>AAAA</strong>, or <strong>CNAME</strong></li>
        <li>in <strong>Name</strong>, enter the subdomain, such as <code>api</code></li>
        <li>in <strong>Content / Value</strong>, enter the server IP or hostname</li>
        <li>save the record</li>
      </ul>

      <h5 class="h6 mt-3 mb-2">4. Make sure the server is configured for that hostname</h5>
      <p>The server itself must be ready to accept requests for that subdomain.</p>
      <ul>
        <li>in NGINX: <code>server_name api.example.com;</code></li>
        <li>in the application: correct domain or base URL</li>
        <li>in SSL: a certificate that covers the subdomain</li>
      </ul>

      <h5 class="h6 mt-3 mb-2">5. Enable SSL for each subdomain</h5>
      <p>If each service is exposed through a different subdomain, each one should have valid HTTPS.</p>

      <h4 class="h6 mt-4 mb-2">When this approach is best</h4>
      <ul>
        <li>multiple separate services</li>
        <li>multiple servers with different roles</li>
        <li>a need to clearly separate website, API, admin panel, mail, or internal tools</li>
        <li>a preference for a clean and easy-to-manage architecture</li>
      </ul>
      <p>Examples:</p>
      <ul>
        <li><code>www.example.com</code> → marketing website</li>
        <li><code>app.example.com</code> → web application</li>
        <li><code>api.example.com</code> → API</li>
        <li><code>status.example.com</code> → status page</li>
        <li><code>mail.example.com</code> → mail service</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Advanced option: separate DNS management for a subdomain</h4>
      <p>In more advanced setups, you can also delegate a subdomain to a separate DNS zone using <strong>NS records</strong>. This is not required in most cases, but it is useful when you want something like <code>api.example.com</code> to be managed separately from <code>example.com</code>.</p>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p>To connect multiple servers under the same main domain, the standard approach is to create different subdomains for each service or server, such as <code>app.example.com</code>, <code>api.example.com</code>, or <code>panel.example.com</code>. Each subdomain gets its own DNS record, usually an <strong>A</strong>, <strong>AAAA</strong>, or <strong>CNAME</strong> record, pointing to the correct server. This makes it easy to separate services in a clean and manageable way.</p>
    `
  },
  {
    id: 15,
    image: 'assets/images/blog/local-offsite-backup-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'Local Backup vs Offsite Backup',
    titleHe: 'מה ההבדל בין backup מקומי ל־offsite backup',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מה ההבדל בין backup מקומי ל־offsite backup</h3>
        <p><strong>Backup מקומי</strong> הוא גיבוי שנשמר באותו אתר פיזי, באותה סביבה, או קרוב מאוד למערכת הראשית, למשל על אותו שרת, על דיסק נוסף באותו שרת, על storage מקומי, או באותו datacenter. כלומר הוא מגן בעיקר מפני כשל חומרה מקומי ולא בהכרח מפני אירוע רחב יותר באתר עצמו.</p>
        <p><strong>Offsite backup</strong> הוא גיבוי שנשמר במיקום נפרד מהמערכת הראשית, למשל בענן, באתר אחר, באזור אחר, או אצל ספק חיצוני. המטרה שלו היא להבטיח שיישאר עותק נפרד גם אם כל הסביבה הראשית נפגעת.</p>

        <h4 class="h6 mt-4 mb-2">ההבדל המעשי</h4>
        <p>ההבדל המרכזי הוא רמת ההגנה. גיבוי מקומי בדרך כלל מהיר יותר לשחזור ונוח יותר לתפעול יומיומי, אבל אם יש כשל חמור בשרת, בתקלה באתר האירוח, במחיקה, בפריצה, בשריפה או באירוע רחב יותר באותו מיקום, גם הגיבוי המקומי עלול להיפגע. לעומת זאת, offsite backup נועד לשמור עותק נפרד שניתן לשחזר גם אם הסביבה הראשית נפגעה באופן משמעותי.</p>

        <h4 class="h6 mt-4 mb-2">יתרונות של backup מקומי</h4>
        <ul>
          <li>שחזור מהיר יותר</li>
          <li>גישה פשוטה יותר</li>
          <li>לעיתים עלות נמוכה יותר</li>
          <li>מתאים לשחזורים יומיומיים ולתקלות קטנות</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">חסרונות של backup מקומי</h4>
        <ul>
          <li>פחות מגן מפני כשל מלא של השרת או האתר</li>
          <li>עלול להיפגע יחד עם המערכת הראשית</li>
          <li>פחות מתאים לבדו לתרחישי disaster recovery אמיתיים</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">יתרונות של offsite backup</h4>
        <ul>
          <li>מגן גם במקרה של כשל באתר הראשי</li>
          <li>חשוב ל־disaster recovery ולהמשכיות עסקית</li>
          <li>תואם להמלצות מוכרות כמו כלל 3-2-1</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">חסרונות של offsite backup</h4>
        <ul>
          <li>לעיתים שחזור איטי יותר</li>
          <li>יכול לדרוש יותר תכנון, רוחב פס או עלות אחסון</li>
          <li>לפעמים פחות נוח לשחזורים קטנים ומהירים לעומת עותק מקומי</li>
        </ul>

     

      <hr class="my-5" />

      <h3 class="h5 mb-3">What is the difference between a local backup and an offsite backup</h3>
      <p>A <strong>local backup</strong> is a backup stored in the same physical site, the same environment, or very close to the primary system, for example on the same server, an additional local disk, local storage, or within the same datacenter. It mainly protects against local hardware failure rather than a wider site-level event.</p>
      <p>An <strong>offsite backup</strong> is a backup stored in a separate location from the primary system, such as in the cloud, another facility, another region, or with an external provider. Its role is to ensure that a separate recoverable copy still exists even if the main environment is heavily impacted.</p>

      <h4 class="h6 mt-4 mb-2">The practical difference</h4>
      <p>The main difference is the level of protection. A local backup is usually faster to restore and easier to use for day-to-day recovery, but if there is a major server failure, hosting-site problem, deletion event, ransomware incident, fire, or another major issue affecting the same location, the local backup may be affected as well. An offsite backup is intended to preserve a separate copy for disaster recovery when the primary environment is compromised.</p>

      <h4 class="h6 mt-4 mb-2">Advantages of local backup</h4>
      <ul>
        <li>faster restore times</li>
        <li>simpler direct access</li>
        <li>often lower cost</li>
        <li>useful for routine recovery and smaller incidents</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Disadvantages of local backup</h4>
      <ul>
        <li>less protection against full site or server failure</li>
        <li>may be affected together with the primary system</li>
        <li>not sufficient by itself for strong disaster recovery planning</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Advantages of offsite backup</h4>
      <ul>
        <li>protects data even if the primary site is impacted</li>
        <li>important for disaster recovery and business continuity</li>
        <li>aligns with established guidance such as the 3-2-1 rule</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Disadvantages of offsite backup</h4>
      <ul>
        <li>restore may be slower</li>
        <li>may require more planning, bandwidth, or storage cost</li>
        <li>can be less convenient for quick small restores than a local copy</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p>A <strong>local backup</strong> is stored in the same hosting environment or physical site, making it faster and more convenient for day-to-day recovery. An <strong>offsite backup</strong> is stored in a separate location, making it far more valuable for disaster recovery if the main environment is lost or compromised. In practice, the strongest approach is to use both, local backup for speed and offsite backup for resilience.</p>
    `
  },
  {
    id: 14,
    image: 'assets/images/blog/cicd-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'CI/CD',
    titleHe: 'מה זה CI/CD',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מה זה CI/CD</h3>
        <p><strong>CI/CD</strong> הוא מודל עבודה מודרני לפיתוח והפצה של תוכנה, שמטרתו להעביר שינויי קוד משלב הפיתוח ועד לסביבת היעד בצורה אוטומטית, עקבית ואמינה יותר. בפועל, מדובר ב־pipeline שמבצע שלבים כמו build, בדיקות, אריזה ופריסה, במקום להסתמך על תהליך ידני לכל שינוי.</p>

        <h4 class="h6 mt-4 mb-2">מה המשמעות של CI</h4>
        <p><strong>Continuous Integration</strong> הוא עיקרון שבו מפתחים ממזגים שינויים לקוד המרכזי לעיתים קרובות, ולאחר כל שינוי רצות פעולות אוטומטיות כמו קומפילציה ובדיקות. המטרה היא לזהות בעיות מוקדם, לצמצם התנגשויות בין שינויים, ולשמור על בסיס קוד שניתן לבנות ולבדוק באופן שוטף.</p>

        <h4 class="h6 mt-4 mb-2">מה המשמעות של CD</h4>
        <p><strong>CD</strong> יכול להתייחס ל־<strong>Continuous Delivery</strong> או ל־<strong>Continuous Deployment</strong>. ב־Continuous Delivery הקוד עובר את כל שלבי האימות ומוכן לפריסה, אך לרוב נשאר שלב אישור לפני production. ב־Continuous Deployment גם שלב זה אוטומטי, וכל שינוי שעבר בהצלחה ממשיך ישירות לפריסה.</p>

        <h4 class="h6 mt-4 mb-2">איך זה עובד בפועל</h4>
        <p>בדרך כלל, הזרימה נראית כך: מפתח דוחף שינוי למאגר הקוד, ה־pipeline מפעיל build, מריץ בדיקות, יוצר artifact או image, ואז ממשיך ל־staging או ל־production לפי הכללים שהוגדרו. רק קוד שעובר בהצלחה את השלבים הנדרשים מתקדם הלאה.</p>

        <h4 class="h6 mt-4 mb-2">מהם היתרונות של CI/CD</h4>
        <p>היתרון המרכזי של CI/CD הוא מעבר מתהליך שברירי ותלוי־אדם לתהליך מדיד, עקבי ושחזורי. בפועל, זה מאפשר לצמצם טעויות ידניות, לאתר תקלות מוקדם יותר, לקצר את זמן ההגעה לפרודקשן, ולשפר את היכולת לשחרר גרסאות קטנות בתדירות גבוהה יותר.</p>

        <h4 class="h6 mt-4 mb-2">מה ההבדל מהשיטה הישנה</h4>
        <p>בשיטה הישנה, תהליך ההפצה היה לעיתים קרובות ידני: מעלים קבצים לשרת, מריצים פקודות ידנית, בודקים חלקית, ומסתמכים על ידע אישי או checklist לא פורמלי. לעומת זאת, ב־CI/CD שלבי ההפצה מוגדרים מראש, נשמרים כחלק מהמערכת, ופועלים בצורה אחידה בכל פעם.</p>

        <h4 class="h6 mt-4 mb-2">למה ארגונים עוברים ל־CI/CD</h4>
        <p>ארגונים עוברים ל־CI/CD משום שהוא מאפשר לפתח ולשחרר תוכנה מהר יותר, עם פחות סיכון ועם יותר יכולת בקרה. כאשר כל שינוי קטן עובר את אותו מסלול קבוע של build, test ו־deploy, קל יותר להרחיב את התהליך לצוותים, לפרויקטים ולסביבות נוספות.</p>

        

      <hr class="my-5" />

      <h3 class="h5 mb-3">What is CI/CD</h3>
      <p><strong>CI/CD</strong> is a modern software delivery model designed to move code changes from development to target environments in a more automated, consistent, and reliable way. In practice, it uses a pipeline to handle stages such as build, testing, packaging, and deployment instead of relying on a manual release process for every change.</p>

      <h4 class="h6 mt-4 mb-2">What CI means</h4>
      <p><strong>Continuous Integration</strong> is the practice of merging code changes into the main codebase frequently, with automated steps such as compilation and testing running after each change. Its purpose is to detect issues earlier, reduce integration conflicts, and keep the codebase in a continuously buildable and testable state.</p>

      <h4 class="h6 mt-4 mb-2">What CD means</h4>
      <p><strong>CD</strong> can mean <strong>Continuous Delivery</strong> or <strong>Continuous Deployment</strong>. In Continuous Delivery, code passes all validation stages and is kept ready for release, usually with a final approval before production. In Continuous Deployment, that last approval step is also automated, so every validated change can move directly into production.</p>

      <h4 class="h6 mt-4 mb-2">How it works in practice</h4>
      <p>A typical workflow looks like this: a developer pushes a code change, the pipeline starts a build, runs tests, creates an artifact or image, and then proceeds to staging or production according to defined rules. Only code that successfully passes the required stages moves forward.</p>

      <h4 class="h6 mt-4 mb-2">What are the benefits of CI/CD</h4>
      <p>The main value of CI/CD is that it replaces a fragile, person-dependent process with one that is measurable, repeatable, and consistent. In practical terms, it reduces manual mistakes, catches issues earlier, shortens time to production, and supports smaller, more frequent releases.</p>

      <h4 class="h6 mt-4 mb-2">How it differs from the old way</h4>
      <p>In the older model, deployment was often manual: files were uploaded to servers by hand, commands were run manually, testing was partial, and the process depended heavily on individual knowledge or informal checklists. In contrast, CI/CD defines those release steps in advance and executes them in a structured, repeatable way every time.</p>

      <h4 class="h6 mt-4 mb-2">Why organizations adopt CI/CD</h4>
      <p>Organizations adopt CI/CD because it enables faster software delivery with lower risk and greater control. When every code change follows the same defined path of build, test, and deployment, it becomes easier to scale the process across teams, projects, and environments.</p>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>CI/CD</strong> is an automated process for managing code build, testing, and deployment, allowing software changes to be released faster, more consistently, and with greater reliability. Compared with older manual release methods, CI/CD reduces human error, improves release quality, and enables teams to ship updates more frequently with better control.</p>
    `
  },
  {
    id: 13,
    image: 'assets/images/blog/docker-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'Containers and Docker',
    titleHe: 'מה זה קונטיינרים ומה זה Docker',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מה זה קונטיינרים ומה זה Docker</h3>
        <p><strong>קונטיינר</strong> הוא תהליך מבודד שרץ עם כל מה שהאפליקציה צריכה כדי לעבוד, כולל הקבצים, הספריות והתלויות שלה. כמה קונטיינרים יכולים לרוץ על אותו host ולשתף את אותו kernel של מערכת ההפעלה.</p>
        <p><strong>Docker</strong> הוא פלטפורמה לבנייה, אריזה, הפצה והרצה של אפליקציות בתוך קונטיינרים. הפלטפורמה מאפשרת להפריד בין האפליקציה לבין התשתית שעליה היא רצה, וכך לפתח, לבדוק ולהעלות גרסאות מהר יותר.</p>

        <h4 class="h6 mt-4 mb-2">מה היתרון של קונטיינרים</h4>
        <p>היתרון המרכזי של קונטיינרים הוא שאפשר להריץ אפליקציה בצורה <strong>עקבית, מבודדת וניידת</strong>.</p>
        <ul>
          <li><strong>Self-contained</strong> — כל קונטיינר כולל את מה שהוא צריך כדי לעבוד</li>
          <li><strong>Isolated</strong> — הקונטיינרים מבודדים יחסית זה מזה ומהמארח</li>
          <li><strong>Independent</strong> — כל קונטיינר מנוהל בנפרד</li>
          <li><strong>Portable</strong> — אותו קונטיינר יכול לרוץ באופן דומה על מחשב פיתוח, על שרת, או בענן</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">יתרונות של Docker וקונטיינרים</h4>
        <ul>
          <li><strong>פריסה עקבית יותר</strong> — מה שעובד בפיתוח יכול לרוץ באותה צורה גם בשרת</li>
          <li><strong>פחות תלות בהתקנות ידניות</strong> — האפליקציה מגיעה עם התלויות שלה</li>
          <li><strong>בידוד טוב יותר בין שירותים</strong> — אפשר להריץ כמה שירותים על אותו שרת בלי לערבב ביניהם</li>
          <li><strong>שימוש יעיל יותר במשאבים לעומת מכונות וירטואליות מלאות</strong> — כי קונטיינרים משתפים את kernel של ה־host ולא מריצים מערכת הפעלה מלאה לכל אפליקציה</li>
          <li><strong>קל יותר לארוז, לשכפל, לעדכן ולהעביר סביבות עבודה</strong></li>
        </ul>
        <p>בסביבות פיתוח, קונטיינרים מאפשרים להפעיל במהירות stack שלם בלי להתקין ישירות על המחשב המקומי את כל הרכיבים כמו Node, MySQL ושירותים נוספים.</p>

        <h4 class="h6 mt-4 mb-2">קונטיינרים לעומת מכונות וירטואליות</h4>
        <p>מכונה וירטואלית כוללת מערכת הפעלה מלאה עם kernel משלה, בעוד שקונטיינר הוא תהליך מבודד שמשתף את kernel של מערכת ההפעלה עם קונטיינרים אחרים על אותו host. לכן, בדרך כלל קונטיינרים קלים יותר ומהירים יותר להפעלה לעומת VM מלא.</p>

        <h4 class="h6 mt-4 mb-2">שימושים נפוצים</h4>
        <ul>
          <li>אפליקציות ווב</li>
          <li>APIs ו־microservices</li>
          <li>בסיסי נתונים ושירותי רקע</li>
          <li>סביבות פיתוח</li>
          <li>workers, cron jobs ו־background services</li>
          <li>סביבות בדיקה ו־CI/CD</li>
        </ul>

      

      <hr class="my-5" />

      <h3 class="h5 mb-3">What are containers and what is Docker</h3>
      <p>A <strong>container</strong> is an isolated process that runs with everything an application needs in order to work, including its files, libraries, and dependencies. Multiple containers on the same host share the same operating system kernel.</p>
      <p><strong>Docker</strong> is a platform for building, packaging, shipping, and running applications in containers. It helps separate the application from the infrastructure so software can be developed, tested, and deployed more quickly.</p>

      <h4 class="h6 mt-4 mb-2">Why containers are useful</h4>
      <p>The main benefit of containers is that applications can run in a more <strong>consistent, isolated, and portable</strong> way.</p>
      <ul>
        <li><strong>Self-contained</strong> — each container includes what it needs to run</li>
        <li><strong>Isolated</strong> — containers are isolated from one another and from the host</li>
        <li><strong>Independent</strong> — each container can be managed separately</li>
        <li><strong>Portable</strong> — the same container can run in a similar way on a developer machine, on a server, or in the cloud</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Advantages of Docker and containers</h4>
      <ul>
        <li><strong>More consistent deployment</strong> — what works in development can run the same way in production</li>
        <li><strong>Less dependence on manual installation</strong> — the application comes with its dependencies</li>
        <li><strong>Better isolation between services</strong> — multiple services can run on the same server without mixing environments</li>
        <li><strong>More efficient resource usage than full virtual machines</strong> — because containers share the host kernel instead of running a full OS per application</li>
        <li><strong>Easier packaging, cloning, updating, and moving of environments</strong></li>
      </ul>
      <p>In development environments, containers make it possible to launch a full stack quickly without installing all components such as Node, MySQL, and other services directly on the local machine.</p>

      <h4 class="h6 mt-4 mb-2">Containers vs virtual machines</h4>
      <p>A virtual machine includes a full operating system with its own kernel, while a container is an isolated process that shares the host operating system kernel with other containers. As a result, containers are usually lighter and faster to start than full virtual machines.</p>

      <h4 class="h6 mt-4 mb-2">Common use cases</h4>
      <ul>
        <li>web applications</li>
        <li>APIs and microservices</li>
        <li>databases and backend services</li>
        <li>development environments</li>
        <li>workers, cron jobs, and background services</li>
        <li>testing and CI/CD environments</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>Containers</strong> provide a way to run applications in an isolated environment together with all required dependencies, so the application behaves consistently across different environments. <strong>Docker</strong> is one of the most popular platforms for managing and running containers, helping teams deploy applications faster with better isolation and portability.</p>
    `
  },
  {
    id: 12,
    image: 'assets/images/blog/ha-scalability-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'High Availability vs Scalability',
    titleHe: 'High Availability לעומת Scalability',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מה זה High Availability ומה זה Scalability</h3>

        <h4 class="h6 mt-4 mb-2">High Availability</h4>
        <p><strong>High Availability</strong> פירושו בנייה של מערכת כך שתישאר זמינה ותמשיך לעבוד גם כאשר רכיב מסוים נכשל. העיקרון המרכזי הוא להימנע מ־<strong>single point of failure</strong> באמצעות יתירות, פיזור שירותים, ושכבות failover אוטומטיות.</p>
        <p>במילים פשוטות: אם שרת אחד נופל, מערכת עם <strong>High Availability</strong> אמורה להמשיך לעבוד דרך שרת אחר, אזור אחר, או עותק נוסף של אותו שירות.</p>
        <p><strong>דוגמאות ל־High Availability:</strong></p>
        <ul>
          <li>כמה שרתי אפליקציה מאחורי Load Balancer</li>
          <li>מסד נתונים עם replica או failover</li>
          <li>פיזור שירותים על פני יותר משרת או יותר מאזור אחד</li>
          <li>ניטור ובדיקות health שמנתבות תעבורה רק לרכיבים בריאים</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">Scalability</h4>
        <p><strong>Scalability</strong> היא היכולת של מערכת להתמודד עם יותר עומס על ידי הוספה או התאמה של משאבים.</p>
        <p>במילים פשוטות: אם נכנסים יותר משתמשים, יש יותר הזמנות, או האפליקציה צריכה יותר כוח עיבוד — מערכת עם <strong>Scalability</strong> יכולה לגדול בלי לקרוס ובלי לדרוש בנייה מחדש של כל התשתית.</p>
        <p><strong>דוגמאות ל־Scalability:</strong></p>
        <ul>
          <li>הוספת עוד שרתי אפליקציה כאשר התנועה גדלה</li>
          <li>הגדלת CPU או RAM לשרת קיים</li>
          <li>פיזור עומס בין כמה instances</li>
          <li>הוספת capacity למסד נתונים, cache או storage לפי צורך</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">ההבדל ביניהם</h4>
        <ul>
          <li><strong>High Availability</strong> עונה על השאלה: <strong>איך המערכת נשארת זמינה כשיש כשל?</strong></li>
          <li><strong>Scalability</strong> עונה על השאלה: <strong>איך המערכת מתמודדת עם יותר עומס או צמיחה?</strong></li>
        </ul>
        <p>אפשר לבנות מערכת שהיא scalable אבל לא highly available, או highly available אבל לא scalable. במערכות בוגרות, בדרך כלל שואפים לשני הדברים יחד.</p>

   
      <hr class="my-5" />

      <h3 class="h5 mb-3">What is High Availability and what is Scalability</h3>

      <h4 class="h6 mt-4 mb-2">High Availability</h4>
      <p><strong>High Availability</strong> means designing a system so it remains available and continues to operate even when one component fails. The core idea is to avoid a <strong>single point of failure</strong> by using redundancy, service distribution, and automatic failover mechanisms.</p>
      <p>In simple terms: if one server fails, a system with <strong>high availability</strong> should continue working through another server, another zone, or another healthy copy of the service.</p>
      <p><strong>Examples of High Availability:</strong></p>
      <ul>
        <li>multiple application servers behind a load balancer</li>
        <li>a database with replica or failover</li>
        <li>distributing services across more than one server or more than one zone</li>
        <li>health checks that route traffic only to healthy components</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Scalability</h4>
      <p><strong>Scalability</strong> is the ability of a system to handle more workload by adding or adjusting resources.</p>
      <p>In simple terms: if more users arrive, more orders are placed, or the application needs more processing power, a <strong>scalable</strong> system can grow without collapsing and without requiring a complete redesign of the infrastructure.</p>
      <p><strong>Examples of Scalability:</strong></p>
      <ul>
        <li>adding more application servers as traffic grows</li>
        <li>increasing CPU or RAM on an existing server</li>
        <li>distributing load across multiple instances</li>
        <li>adding more database, cache, or storage capacity as needed</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">The difference between them</h4>
      <ul>
        <li><strong>High Availability</strong> answers: <strong>How does the system stay online when something fails?</strong></li>
        <li><strong>Scalability</strong> answers: <strong>How does the system handle growth and more load?</strong></li>
      </ul>
      <p>A system can be scalable without being highly available, and highly available without being highly scalable. Mature platforms usually aim for both.</p>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>High Availability</strong> is an infrastructure design approach that keeps services online during failures by using redundancy, distribution, and failover. <strong>Scalability</strong> is the ability of a system to grow and handle more demand by adding or adjusting resources when needed.</p>
    `
  },
  {
    id: 11,
    image: 'assets/images/blog/vps-use-cases-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'What can I do with my VPS server?',
    titleHe: 'מה אפשר לעשות עם השרת VPS שלי?',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מה אפשר לעשות עם השרת VPS שלי?</h3>
        <p>שרת <strong>VPS</strong> הוא שרת וירטואלי שמעניק לכם יותר שליטה, בידוד וגמישות לעומת אחסון שיתופי. עם VPS אפשר להתקין מערכת הפעלה, תוכנות מותאמות והגדרות שרת משלכם, ולקבל גישה בלעדית יותר למשאבים כמו זיכרון וכוח עיבוד.</p>

        <h4 class="h6 mt-4 mb-2">שימושים נפוצים ל־VPS</h4>
        <ul>
          <li><strong>אתרי אינטרנט וחנויות אונליין</strong> — אתרי WordPress, WooCommerce, אתרי תוכן, אתרי חברה וחנויות דיגיטליות.</li>
          <li><strong>אפליקציות ווב ומובייל</strong> — backend, API, לוחות ניהול, מערכות SaaS וכלים עסקיים.</li>
          <li><strong>מערכות עסקיות פנימיות</strong> — שיתוף קבצים, גיבויים, הנהלת חשבונות, CRM או יישומים ארגוניים קטנים.</li>
          <li><strong>סביבות פיתוח ובדיקות</strong> — שרת dev, staging, QA, בדיקות deployment או סביבת פיתוח לצוותים.</li>
          <li><strong>קונטיינרים ושירותים מותאמים</strong> — Docker, reverse proxy, workers, cron jobs, מיקרו־שירותים ותהליכים מותאמים.</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">למה בוחרים VPS</h4>
        <p>בוחרים VPS כשצריך יותר חופש מאחסון שיתופי. אפשר להתקין תוכנה מותאמת, קונפיגורציות מיוחדות, אינטגרציות עם מערכות אחרות, ואמצעי אבטחה כמו חומות אש. VPS מתאים למגוון רחב של אתרים ואפליקציות, כולל עומסי CPU, RAM או storage שונים.</p>

        <h4 class="h6 mt-4 mb-2">למי זה מתאים</h4>
        <ul>
          <li>עסקים שצריכים יותר שליטה על סביבת האחסון</li>
          <li>אתרים עם תנועה גבוהה יותר</li>
          <li>חנויות אונליין</li>
          <li>מערכות מותאמות אישית</li>
          <li>מפתחים או צוותים שצריכים גישת שרת אמיתית</li>
          <li>לקוחות שרוצים להריץ כמה שירותים על אותו שרת</li>
        </ul>

     

      <hr class="my-5" />

      <h3 class="h5 mb-3">What can I do with my VPS server?</h3>
      <p>A <strong>VPS</strong> is a virtual server that gives you more control, isolation, and flexibility than shared hosting. With VPS hosting you can install your own operating system, custom software, and server configuration, while getting more exclusive access to resources such as memory and processing power.</p>

      <h4 class="h6 mt-4 mb-2">Common VPS use cases</h4>
      <ul>
        <li><strong>Websites and online stores</strong> — WordPress sites, WooCommerce stores, content websites, business websites, and ecommerce platforms.</li>
        <li><strong>Web and mobile applications</strong> — backends, APIs, admin dashboards, SaaS platforms, and business tools.</li>
        <li><strong>Internal business systems</strong> — file sharing, backups, accounting tools, CRM systems, or small internal business applications.</li>
        <li><strong>Development and testing environments</strong> — dev servers, staging environments, QA, deployment testing, and team development workflows.</li>
        <li><strong>Containers and custom services</strong> — Docker, reverse proxies, workers, cron jobs, microservices, and custom server processes.</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Why people choose VPS</h4>
      <p>People choose VPS when they need more freedom than shared hosting can offer. VPS environments allow custom software, custom configurations, integrations with other systems, and custom security measures such as firewalls. VPS hosting is suitable for a wide range of websites and applications, including CPU-intensive, memory-intensive, and storage-intensive workloads.</p>

      <h4 class="h6 mt-4 mb-2">Who it is for</h4>
      <ul>
        <li>businesses that need more control over the hosting environment</li>
        <li>higher-traffic websites</li>
        <li>online stores</li>
        <li>custom applications</li>
        <li>developers or teams that need real server access</li>
        <li>customers who want to run multiple services on one server</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p>A <strong>VPS</strong> can be used to run WordPress websites, WooCommerce stores, web applications, APIs, internal business systems, development and staging environments, and containers or other custom services. It is especially suitable for users who need more control, flexibility, and more clearly allocated resources than shared hosting.</p>
    `
  },
  {
    id: 10,
    image: 'assets/images/blog/managed-vps-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'Managed VPS vs Unmanaged VPS',
    titleHe: 'שרת VPS מנוהל לעומת שרת VPS לא מנוהל',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">שרת VPS מנוהל לעומת שרת VPS לא מנוהל</h3>
        <p><strong>שרת VPS לא מנוהל</strong> הוא שרת וירטואלי שבו ספק האחסון מספק את התשתית והזמינות הבסיסית של השרת, אבל האחריות על ניהול מערכת ההפעלה, עדכונים, אבטחה, גיבויים, ניטור והגדרות נשארת בעיקר אצל הלקוח.</p>
        <p><strong>שרת VPS מנוהל</strong> הוא שרת וירטואלי שבו הספק לא רק מספק את השרת, אלא גם מטפל בחלק נרחב מהניהול השוטף של הסביבה.</p>

        <h4 class="h6 mt-4 mb-2">מה כולל VPS מנוהל</h4>
        <p>בשירות VPS מנוהל, הלקוח מקבל שרת וירטואלי יחד עם שכבת ניהול ושירות. אצלך, השירות המנוהל כולל:</p>
        <ul>
          <li><strong>Full Management</strong> — ניהול שוטף של סביבת השרת</li>
          <li><strong>Snapshot Backup</strong> — יצירת snapshots לשחזור מהיר</li>
          <li><strong>Remote Cloud Backup (7 days)</strong> — גיבוי מרוחק בענן עם שמירה ל־7 ימים</li>
          <li><strong>Updates & Security Patches</strong> — עדכוני מערכת ותיקוני אבטחה</li>
          <li><strong>Server Monitoring</strong> — ניטור שרת ומשאבים</li>
          <li><strong>Infrastructure Support</strong> — תמיכה תשתיתית</li>
          <li><strong>Technical Consulting</strong> — ליווי וייעוץ טכני</li>
          <li><strong>SSL Certificate</strong> — תעודת SSL</li>
          <li><strong>Cyber Security System</strong> — שכבת אבטחה והקשחה</li>
          <li><strong>High-Speed SSD Infrastructure</strong> — תשתית SSD מהירה</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">יתרונות של VPS מנוהל</h4>
        <ul>
          <li>פחות עומס טכני על הלקוח</li>
          <li>פחות אחריות ישירה על עדכונים, patching ואבטחה</li>
          <li>גיבויים וניטור כחלק מהשירות</li>
          <li>גישה קלה יותר לעזרה תשתיתית וייעוץ</li>
          <li>מתאים יותר לעסקים שרוצים להתמקד באפליקציה או באתר ולא בניהול השרת עצמו</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">חסרונות של VPS מנוהל</h4>
        <ul>
          <li>בדרך כלל מחיר גבוה יותר לעומת VPS לא מנוהל</li>
          <li>לעיתים פחות חופש מוחלט ברמת השרת לעומת ניהול עצמי מלא</li>
          <li>חלק מהפעולות עשויות להתבצע לפי נהלי הספק או דרך התמיכה שלו</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">יתרונות של VPS לא מנוהל</h4>
        <ul>
          <li>יותר שליטה ישירה בשרת</li>
          <li>יותר חופש להתקנות, קונפיגורציה והתאמות</li>
          <li>לרוב עלות נמוכה יותר</li>
          <li>מתאים למפתחים, sysadmins ו־DevOps שרוצים לנהל הכול בעצמם</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">חסרונות של VPS לא מנוהל</h4>
        <ul>
          <li>דורש יותר ידע טכני</li>
          <li>הלקוח אחראי לעדכונים, אבטחה, גיבויים וניטור</li>
          <li>פתרון תקלות תפעוליות הוא באחריות הלקוח או הצוות שלו</li>
          <li>פחות מתאים למי שאין לו זמן או ניסיון בניהול שרתים</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">למי מתאים כל אחד</h4>
        <p><strong>VPS מנוהל מתאים ל:</strong></p>
        <ul>
          <li>עסקים שרוצים שרת פרטי בלי לנהל את כולו לבד</li>
          <li>אתרי WordPress, WooCommerce, מערכות עסקיות ואפליקציות ווב</li>
          <li>לקוחות שרוצים תמיכה, ניטור, גיבויים ואבטחה כחלק מהשירות</li>
          <li>מי שצריך איזון בין שליטה לבין שקט תפעולי</li>
        </ul>
        <p><strong>VPS לא מנוהל מתאים ל:</strong></p>
        <ul>
          <li>מפתחים, אנשי סיסטם ו־DevOps</li>
          <li>פרויקטים שדורשים שליטה מלאה במערכת</li>
          <li>לקוחות שמסוגלים לנהל לבד Linux, אבטחה, patching, גיבויים וניטור</li>
          <li>סביבות שבהן רוצים למזער עלות ולנהל הכול עצמאית</li>
        </ul>

       

      <hr class="my-5" />

      <h3 class="h5 mb-3">Managed VPS vs Unmanaged VPS</h3>
      <p>An <strong>unmanaged VPS</strong> is a virtual server where the hosting provider supplies the infrastructure and basic server availability, but responsibility for operating system management, updates, security, backups, monitoring, and configuration remains mostly with the customer.</p>
      <p>A <strong>managed VPS</strong> is a virtual server where the provider delivers not only the server itself, but also a broader operational service layer.</p>

      <h4 class="h6 mt-4 mb-2">What a managed VPS includes</h4>
      <p>With a managed VPS, the customer receives a virtual server together with an operational management layer. In your service, the managed offering includes:</p>
      <ul>
        <li><strong>Full Management</strong> — ongoing server environment management</li>
        <li><strong>Snapshot Backup</strong> — snapshots for quick recovery</li>
        <li><strong>Remote Cloud Backup (7 days)</strong> — remote cloud backup retention for 7 days</li>
        <li><strong>Updates & Security Patches</strong> — operating system updates and security patching</li>
        <li><strong>Server Monitoring</strong> — server and resource monitoring</li>
        <li><strong>Infrastructure Support</strong> — infrastructure-level support</li>
        <li><strong>Technical Consulting</strong> — technical guidance and consulting</li>
        <li><strong>SSL Certificate</strong> — SSL certificate support</li>
        <li><strong>Cyber Security System</strong> — security hardening and protection layer</li>
        <li><strong>High-Speed SSD Infrastructure</strong> — fast SSD-based infrastructure</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Advantages of managed VPS</h4>
      <ul>
        <li>less technical workload for the customer</li>
        <li>less direct responsibility for updates, patching, and security</li>
        <li>backups and monitoring included as part of the service</li>
        <li>easier access to infrastructure help and technical guidance</li>
        <li>better suited for businesses that want to focus on their application or website rather than server administration</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Disadvantages of managed VPS</h4>
      <ul>
        <li>usually higher cost than unmanaged VPS</li>
        <li>sometimes less total freedom at the server level than full self-management</li>
        <li>some operations may follow the provider’s procedures or support workflow</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Advantages of unmanaged VPS</h4>
      <ul>
        <li>more direct server control</li>
        <li>more freedom for custom installations, configuration, and tuning</li>
        <li>usually lower cost</li>
        <li>better suited for developers, system administrators, and DevOps teams who want to manage everything themselves</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Disadvantages of unmanaged VPS</h4>
      <ul>
        <li>requires more technical knowledge</li>
        <li>the customer is responsible for updates, security, backups, and monitoring</li>
        <li>operational troubleshooting is mainly handled by the customer or their team</li>
        <li>less suitable for users who do not have time or experience managing servers</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Who each option is for</h4>
      <p><strong>Managed VPS is best suited for:</strong></p>
      <ul>
        <li>businesses that want a private server without fully managing it alone</li>
        <li>WordPress, WooCommerce, business systems, and web applications</li>
        <li>customers who want support, monitoring, backups, and security included</li>
        <li>users who want a balance between control and operational peace of mind</li>
      </ul>
      <p><strong>Unmanaged VPS is best suited for:</strong></p>
      <ul>
        <li>developers, system administrators, and DevOps teams</li>
        <li>projects that require full operating-system-level control</li>
        <li>customers able to manage Linux, security, patching, backups, and monitoring independently</li>
        <li>environments where minimizing cost and maximizing self-management is the priority</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p>A <strong>managed VPS</strong> gives you a virtual server together with a full management layer, including backups, monitoring, updates, security, SSL, and infrastructure support. An <strong>unmanaged VPS</strong> gives you the server itself, while responsibility for configuration, maintenance, security, and monitoring remains mostly with you.</p>
    `
  },
  {
    id: 9,
    image: 'assets/images/blog/woocommerce-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'WooCommerce',
    titleHe: 'WooCommerce',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">WooCommerce</h3>
        <p><strong>WooCommerce</strong> הוא תוסף מסחר אלקטרוני ל־WordPress שמאפשר להפוך אתר WordPress לחנות אונליין. לפי התיעוד הרשמי, מדובר בפלטפורמת eCommerce בקוד פתוח ל־WordPress, המיועדת למכירת מוצרים פיזיים, מוצרים דיגיטליים, שירותים ועוד.</p>

        <h4 class="h6 mt-4 mb-2">איך מתקינים WooCommerce</h4>
        <p>כדי להשתמש ב־WooCommerce, צריך קודם אתר WordPress פעיל, משום ש־WooCommerce הוא תוסף של WordPress ולא מערכת נפרדת.</p>
        <p>ההתקנה יכולה להתבצע בכמה דרכים:</p>
        <ul>
          <li><strong>התקנה מתוך WordPress Admin</strong>: נכנסים ל־<strong>Plugins → Add New Plugin</strong>, מחפשים <strong>WooCommerce</strong>, לוחצים <strong>Install Now</strong> ואז <strong>Activate</strong>. לאחר ההפעלה, בדרך כלל נפתח <strong>Setup Wizard / Onboarding Wizard</strong> שמלווה את ההגדרות הראשונות של החנות.</li>
          <li><strong>התקנה אוטומטית דרך פאנל האחסון</strong>: בחלק משירותי האחסון ניתן להתקין WordPress או WordPress עם WooCommerce דרך <strong>WordPress Manager</strong> או <strong>Auto Installer</strong> בפאנל הניהול. לאחר שהאתר עולה, אפשר להשלים את הגדרות החנות דרך ה־Setup Wizard של WooCommerce.</li>
        </ul>
        <p>במהלך ההגדרה הראשונית בדרך כלל מגדירים:</p>
        <ul>
          <li>פרטי החנות</li>
          <li>מטבע</li>
          <li>תשלומים</li>
          <li>משלוחים</li>
          <li>מיסים</li>
          <li>מוצרים ראשונים</li>
          <li>תבנית או התאמות בסיסיות לחנות</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">למה WooCommerce כל כך פופולרי</h4>
        <ul>
          <li><strong>מבוסס WordPress</strong> — הוא מתחבר ישירות למערכת ניהול התוכן הפופולרית בעולם, ולכן מתאים מאוד לאתרים שכבר רצים על WordPress.</li>
          <li><strong>קוד פתוח וגמיש</strong> — WooCommerce מתארת את הפלטפורמה כ־open-source וככזו שמאפשרת שליטה גבוהה יותר על החנות, הנתונים וההתאמות.</li>
          <li><strong>ליבת מערכת חינמית</strong> — ליבת WooCommerce זמינה ללא תשלום, מה שהופך אותה לנגישה לעסקים קטנים, מפתחים וסוכנויות.</li>
          <li><strong>אקוסיסטם רחב</strong> — קיימים תוספים, הרחבות, תבניות ואינטגרציות רבות שמאפשרות להרחיב את החנות לפי צורך.</li>
          <li><strong>מתאים לעסקים בצמיחה</strong> — WooCommerce מציגה את עצמה כפלטפורמה שמאפשרת לבנות חנות מותאמת אישית ולצמוח בלי להיות נעולים לפתרון סגור.</li>
        </ul>

       

      <hr class="my-5" />

      <h3 class="h5 mb-3">WooCommerce</h3>
      <p><strong>WooCommerce</strong> is an eCommerce plugin for WordPress that turns a WordPress website into an online store. According to the official documentation, it is an open-source eCommerce platform for WordPress designed for selling physical products, digital products, services, and more.</p>

      <h4 class="h6 mt-4 mb-2">How to install WooCommerce</h4>
      <p>To use WooCommerce, you first need an active WordPress website, because WooCommerce is a WordPress plugin rather than a standalone platform.</p>
      <p>Installation can usually be done in a few ways:</p>
      <ul>
        <li><strong>Install from WordPress Admin</strong>: Go to <strong>Plugins → Add New Plugin</strong>, search for <strong>WooCommerce</strong>, click <strong>Install Now</strong>, and then <strong>Activate</strong>. After activation, the <strong>Setup Wizard / Onboarding Wizard</strong> usually opens and guides you through the initial store configuration.</li>
        <li><strong>Automatic installation through the hosting panel</strong>: In some hosting environments, WordPress or WordPress with WooCommerce can be deployed through a <strong>WordPress Manager</strong> or <strong>Auto Installer</strong> in the hosting panel. Once the site is available, the WooCommerce Setup Wizard can be used to complete the store configuration.</li>
      </ul>
      <p>During the initial setup, users typically configure:</p>
      <ul>
        <li>store details</li>
        <li>currency</li>
        <li>payments</li>
        <li>shipping</li>
        <li>taxes</li>
        <li>first products</li>
        <li>theme or basic store appearance settings</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Why WooCommerce is so popular</h4>
      <ul>
        <li><strong>Built on WordPress</strong> — it works directly with the world’s most widely used content management system, making it a natural fit for WordPress websites.</li>
        <li><strong>Open-source and flexible</strong> — WooCommerce describes the platform as open-source and emphasizes greater control over the store, data, and customization.</li>
        <li><strong>Free core platform</strong> — the core WooCommerce platform is available at no cost, which makes it accessible for small businesses, developers, and agencies.</li>
        <li><strong>Large ecosystem</strong> — there are many extensions, themes, integrations, and documentation resources available for expanding and adapting the store.</li>
        <li><strong>Suitable for growing businesses</strong> — WooCommerce positions itself as a customizable commerce platform that allows merchants to build and grow without being locked into a closed system.</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>WooCommerce</strong> is an eCommerce plugin for WordPress that allows you to build an online store on top of an existing WordPress website. It can be installed directly from WordPress or, in some hosting environments, through automatic installation in the hosting control panel. Its popularity comes from the combination of WordPress, open-source flexibility, and the ability to expand the store as needed.</p>
    `
  },
  {
    id: 8,
    image: 'assets/images/blog/vps-vs-shared-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'Virtual Server vs Shared Website Hosting',
    titleHe: 'שרת וירטואלי לעומת אחסון אתר שיתופי',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">שרת וירטואלי לעומת אחסון אתר שיתופי</h3>
        <p><strong>אחסון אתר שיתופי</strong> הוא שירות שבו מספר אתרים ולקוחות חולקים את אותו שרת ואת אותם משאבים הכלליים. בדרך כלל מקבלים גישה לפאנל ניהול ולאזור האתר, אבל לא לשרת עצמו ברמת root.</p>
        <p><strong>שרת וירטואלי (VPS)</strong> הוא סביבה וירטואלית מבודדת שרצה על גבי שרת פיזי, אך עם הקצאת משאבים משלה. זהו פתרון שמספק יותר בידוד, יותר גמישות, ויותר שליטה על סביבת העבודה לעומת אחסון שיתופי.</p>

        <h4 class="h6 mt-4 mb-2">היתרונות של אחסון שיתופי</h4>
        <ul>
          <li>מחיר נמוך יותר</li>
          <li>ניהול פשוט יותר</li>
          <li>פחות צורך בידע טכני</li>
          <li>פאנל מוכן לעבודה מהירה</li>
        </ul>
        <p>זה בדרך כלל פתרון טוב לאתרי תדמית, בלוגים, אתרי עסק קטן או אתרים בתחילת הדרך.</p>

        <h4 class="h6 mt-4 mb-2">החסרונות של אחסון שיתופי</h4>
        <ul>
          <li>פחות שליטה על סביבת השרת</li>
          <li>פחות גמישות טכנית</li>
          <li>ביצועים שעלולים להיות מושפעים מאתרים אחרים על אותו שרת</li>
          <li>מגבלות גדולות יותר על התאמות מיוחדות, תוכנות, תצורות וגישות מערכת</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">היתרונות של VPS</h4>
        <ul>
          <li>יותר בידוד בין סביבות</li>
          <li>יותר שליטה וגמישות</li>
          <li>משאבים מוקצים בצורה ברורה יותר</li>
          <li>אפשרות לגישת root ולהתקנות מותאמות</li>
          <li>התאמה טובה יותר לאפליקציות, עומסים ותהליכים מיוחדים</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">החסרונות של VPS</h4>
        <ul>
          <li>יקר יותר מאחסון שיתופי</li>
          <li>דורש יותר ידע טכני או שירות מנוהל</li>
          <li>דורש יותר אחריות על אבטחה, תחזוקה, עדכונים וניטור אם הוא לא מנוהל</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">למי מתאים כל אחד</h4>
        <p><strong>אחסון שיתופי מתאים ל:</strong></p>
        <ul>
          <li>אתרי תדמית</li>
          <li>בלוגים</li>
          <li>אתרי WordPress קטנים</li>
          <li>עסקים קטנים שרוצים פשטות ועלות נמוכה</li>
          <li>מי שלא רוצה לנהל שרת</li>
        </ul>
        <p><strong>VPS מתאים ל:</strong></p>
        <ul>
          <li>אתרים עם יותר תנועה</li>
          <li>חנויות אונליין</li>
          <li>מערכות מותאמות אישית</li>
          <li>כמה אתרים על אותה סביבה</li>
          <li>פרויקטים שצריכים גישה עמוקה יותר לשרת</li>
          <li>מי שצריך גמישות, ביצועים ושליטה גדולים יותר</li>
        </ul>

       

      <hr class="my-5" />

      <h3 class="h5 mb-3">Virtual Server vs Shared Website Hosting</h3>
      <p><strong>Shared hosting</strong> is a service where multiple websites and customers share the same server and its general resources. In most cases, users get access to a hosting control panel and their website area, but not full root-level access to the server itself.</p>
      <p>A <strong>virtual private server (VPS)</strong> is an isolated virtual environment running on top of a physical server, with its own allocated resources. It provides more isolation, more flexibility, and more control over the environment than shared hosting.</p>

      <h4 class="h6 mt-4 mb-2">Advantages of shared hosting</h4>
      <ul>
        <li>lower cost</li>
        <li>easier day-to-day management</li>
        <li>less technical complexity</li>
        <li>a ready-to-use control panel experience</li>
      </ul>
      <p>It is generally a good fit for brochure websites, blogs, small business websites, and early-stage projects.</p>

      <h4 class="h6 mt-4 mb-2">Disadvantages of shared hosting</h4>
      <ul>
        <li>less control over the server environment</li>
        <li>less technical flexibility</li>
        <li>performance can be affected by other sites on the same server</li>
        <li>more limits on custom software, advanced configuration, and system-level access</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Advantages of VPS</h4>
      <ul>
        <li>stronger isolation between environments</li>
        <li>more control and flexibility</li>
        <li>more clearly allocated resources</li>
        <li>the ability to use root access and custom installations</li>
        <li>better suitability for applications, higher traffic, and custom workloads</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Disadvantages of VPS</h4>
      <ul>
        <li>higher cost than shared hosting</li>
        <li>more technical knowledge required, unless it is managed</li>
        <li>more responsibility for security, maintenance, updates, and monitoring if unmanaged</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Who each option is for</h4>
      <p><strong>Shared hosting is usually best for:</strong></p>
      <ul>
        <li>brochure websites</li>
        <li>blogs</li>
        <li>small WordPress websites</li>
        <li>small businesses that want simplicity and lower cost</li>
        <li>users who do not want to manage a server</li>
      </ul>
      <p><strong>VPS is usually better for:</strong></p>
      <ul>
        <li>websites with higher traffic</li>
        <li>online stores</li>
        <li>custom applications</li>
        <li>multiple sites in one environment</li>
        <li>projects that need deeper server access</li>
        <li>users who need more flexibility, performance, and control</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p><strong>Shared hosting</strong> is a better fit for simpler websites that need an affordable and easy-to-manage solution. A <strong>VPS</strong> is a better fit for users who need more control, performance, and flexibility, with a more isolated environment and more clearly allocated resources.</p>
    `
  },
  {
    id: 7,
    image: 'assets/images/blog/cdn-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'CDN',
    titleHe: 'CDN',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">CDN</h3>
        <p>CDN הוא שירות שמגיש קבצים ותוכן של האתר דרך רשת שרתים מבוזרת, במקום שכל בקשה תגיע ישירות לשרת המקור. ב־Cloudflare התעבורה עוברת דרך הרשת שלהם כ־reverse proxy, מה שמאפשר להגיש תוכן קרוב יותר למבקר וגם להגן על שרת המקור.</p>

        <h4 class="h6 mt-4 mb-2">למה צריך CDN</h4>
        <p>המטרה המרכזית של CDN היא <strong>שיפור מהירות טעינה, הפחתת עומס על שרת המקור, ושיפור היציבות</strong>. כאשר קבצים סטטיים כמו תמונות, CSS, JavaScript ופונטים נשמרים בקצה הרשת, פחות בקשות מגיעות לשרת שלכם והמשתמשים מקבלים את התוכן מהר יותר. Cloudflare מתעדת שכברירת מחדל נשמרים במטמון סוגים מסוימים של קבצים סטטיים, בעוד HTML אינו נשמר במטמון ללא הגדרה נוספת.</p>

        <h4 class="h6 mt-4 mb-2">מה מקבלים ב־Cloudflare מעבר ל־CDN</h4>
        <ul>
          <li><strong>DNS מנוהל</strong> — ניהול zone, nameservers ורשומות DNS</li>
          <li><strong>WAF</strong> — חומת אש לאפליקציות ווב עם חוקים מובנים ומותאמים אישית</li>
          <li><strong>DDoS Protection</strong> — הגנה מפני מתקפות עומס</li>
          <li><strong>SSL/TLS</strong> — ניהול והקשחת חיבור מאובטח</li>
          <li><strong>Load Balancing</strong> — ניתוב תעבורה בין מקורות שונים</li>
          <li><strong>Zero Trust / Access / Tunnel</strong> — גישה מאובטחת לשירותים פנימיים</li>
          <li><strong>Workers / Pages / R2 ושירותי פלטפורמה נוספים</strong> — יכולות פיתוח והרצה על גבי הרשת של Cloudflare</li>
        </ul>

       

      <hr class="my-5" />

      <h3 class="h5 mb-3">CDN</h3>
      <p>A CDN is a service that delivers website files and content through a distributed network of servers instead of sending every request directly to the origin server. With Cloudflare, traffic passes through Cloudflare’s network as a reverse proxy, which helps serve content closer to the visitor while also protecting the origin server.</p>

      <h4 class="h6 mt-4 mb-2">Why use a CDN</h4>
      <p>The main reason to use a CDN is to <strong>improve loading speed, reduce origin server load, and improve stability</strong>. When static assets such as images, CSS, JavaScript, and fonts are cached at the network edge, fewer requests reach the main server and visitors receive content faster. Cloudflare documents that certain static file types are cached by default, while HTML is not cached unless additional configuration is applied.</p>

      <h4 class="h6 mt-4 mb-2">What Cloudflare provides beyond CDN</h4>
      <ul>
        <li><strong>Managed DNS</strong> — zone, nameserver, and DNS record management</li>
        <li><strong>WAF</strong> — web application firewall with managed and custom rules</li>
        <li><strong>DDoS Protection</strong> — protection against denial-of-service attacks</li>
        <li><strong>SSL/TLS</strong> — secure connection handling and encryption features</li>
        <li><strong>Load Balancing</strong> — traffic distribution across multiple origins</li>
        <li><strong>Zero Trust / Access / Tunnel</strong> — secure access to internal services</li>
        <li><strong>Workers / Pages / R2 and additional platform services</strong> — development and application services built on Cloudflare’s network</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Short website version</h4>
      <p>A <strong>CDN</strong> improves website performance by delivering content through a global network of servers instead of placing every request on the origin server. In addition to performance improvements, platforms such as Cloudflare also provide managed DNS, WAF, DDoS protection, SSL, Zero Trust services, and additional platform tools — making it much more than just a CDN.</p>
    `
  },
  {
    id: 6,
    image: 'assets/images/blog/backup-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'WordPress Backup & Restore',
    titleHe: 'גיבוי ושחזור WordPress',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">WordPress Backup & Restore</h3>
        <p>מומלץ לבצע גיבוי ושחזור של אתר WordPress באמצעות <strong>תוסף גיבוי חיצוני</strong>, ולא להסתמך רק על גיבויי השרת. WordPress מדגישה שגיבוי תקין צריך לכלול גם את <strong>קבצי האתר</strong> וגם את <strong>מסד הנתונים</strong>, ושמומלץ לשמור עותקים זמינים לשחזור.</p>

        <h4 class="h6 mt-4 mb-2">התקנת תוסף הגיבוי</h4>
        <p>מתוך לוח הבקרה של WordPress היכנסו לנתיב:<br /><strong>Plugins → Add New</strong><br />חפשו תוסף גיבוי מתאים, לחצו <strong>Install</strong>, ואז <strong>Activate</strong>.</p>
        <p>לאחר ההפעלה, תוסף הגיבוי יופיע בדרך כלל באחד מהמיקומים הבאים:</p>
        <ul>
          <li><strong>Settings → [Plugin Name]</strong></li>
          <li><strong>Tools → [Plugin Name]</strong></li>
          <li>או כתפריט נפרד בסרגל הצד של WordPress</li>
        </ul>
        <p>המיקום המדויק תלוי בתוסף עצמו, ולכן חשוב לבדוק היכן נוסף התפריט לאחר ההפעלה. בדוגמה של UpdraftPlus, מסך הגיבוי מופיע תחת <strong>Settings → UpdraftPlus Backups</strong>.</p>

        <h4 class="h6 mt-4 mb-2">מה צריך לכלול בגיבוי</h4>
        <p>גיבוי מלא צריך לכלול לפחות:</p>
        <ul>
          <li><strong>מסד נתונים</strong></li>
          <li><strong>קבצי WordPress</strong></li>
          <li><strong>תוספים</strong></li>
          <li><strong>תבניות</strong></li>
          <li><strong>Uploads / Media</strong></li>
        </ul>
        <p>באתר WordPress, קבצי האתר נמצאים בדרך כלל תחת תיקיית ההתקנה, ובמיוחד תחת:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>wp-content/</code><br />
          <code>wp-content/plugins/</code><br />
          <code>wp-content/themes/</code><br />
          <code>wp-content/uploads/</code>
        </div>

        <h4 class="h6 mt-4 mb-2">הגדרת יעד גיבוי חיצוני</h4>
        <p>לאחר פתיחת מסך התוסף, חפשו בדרך כלל אזורים בשם:</p>
        <ul>
          <li><strong>Settings</strong></li>
          <li><strong>Storage</strong></li>
          <li><strong>Remote Storage</strong></li>
          <li><strong>Destination</strong></li>
        </ul>
        <p>שם מגדירים את יעד הגיבוי. מומלץ מאוד לבחור <strong>offsite backup</strong>, כלומר יעד חיצוני כמו אחסון ענן, שרת מרוחק או שירות חיצוני אחר, ולא רק אחסון על אותו שרת WordPress.</p>

        <h4 class="h6 mt-4 mb-2">יצירת גיבוי ראשון</h4>
        <p>במסך הראשי של התוסף, חפשו כפתור כמו:</p>
        <ul>
          <li><strong>Backup Now</strong></li>
          <li><strong>Run Backup</strong></li>
          <li><strong>Create Backup</strong></li>
        </ul>
        <p>לפני עדכון WordPress, תוסף, תבנית או שינוי משמעותי באתר, מומלץ להפעיל <strong>גיבוי ידני נוסף</strong>.</p>

        <h4 class="h6 mt-4 mb-2">קביעת גיבויים אוטומטיים</h4>
        <p>בתוסף חפשו אפשרויות כמו:</p>
        <ul>
          <li><strong>Schedule</strong></li>
          <li><strong>Backup Schedule</strong></li>
          <li><strong>Files Schedule</strong></li>
          <li><strong>Database Schedule</strong></li>
        </ul>
        <p>רצוי להגדיר גיבוי אוטומטי נפרד לקבצים ולמסד הנתונים כאשר התוסף מאפשר זאת.</p>

        <h4 class="h6 mt-4 mb-2">שחזור אתר מתוך התוסף</h4>
        <p>כאשר צריך לשחזר, היכנסו למסך התוסף וחפשו בדרך כלל אחד מהאזורים:</p>
        <ul>
          <li><strong>Existing Backups</strong></li>
          <li><strong>Restore</strong></li>
          <li><strong>Backup / Restore</strong></li>
          <li><strong>Import Backup</strong></li>
        </ul>
        <p>בתוספים מסוימים, כמו UpdraftPlus, מסלול השחזור הוא:<br /><strong>Settings → UpdraftPlus Backups → Existing Backups → Restore</strong>.<br />אם קבצי הגיבוי לא מופיעים ברשימה, בחלק מהתוספים אפשר להעלות אותם ידנית דרך אפשרות כמו <strong>Upload backup files</strong> ואז להתחיל שחזור.</p>

        <h4 class="h6 mt-4 mb-2">בדיקות מומלצות אחרי שחזור</h4>
        <p>לאחר שחזור, בדקו לפחות:</p>
        <ul>
          <li>שהאתר הראשי נפתח</li>
          <li>ש־<code>/wp-admin</code> נפתח</li>
          <li>שתוספים ותבניות נטענים תקין</li>
          <li>שתמונות מתוך <code>wp-content/uploads/</code> זמינות</li>
          <li>שאין שגיאת מסד נתונים</li>
        </ul>
        <p>נתיבים נפוצים לבדיקה:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>/wp-admin</code><br />
          <code>/wp-content/uploads/</code><br />
          <code>/wp-content/plugins/</code><br />
          <code>/wp-content/themes/</code>
        </div>
      </div>

      <hr class="my-5" />

      <h3 class="h5 mb-3">WordPress Backup & Restore</h3>
      <p>It is recommended to back up and restore a WordPress site using a <strong>dedicated external backup plugin</strong>, rather than relying only on server-level backups. WordPress states that a proper backup should include both the <strong>site files</strong> and the <strong>database</strong>, and that recoverable backup copies should be maintained.</p>

      <h4 class="h6 mt-4 mb-2">Install the backup plugin</h4>
      <p>From the WordPress dashboard, go to:<br /><strong>Plugins → Add New</strong><br />Search for a backup plugin, click <strong>Install</strong>, then <strong>Activate</strong>.</p>
      <p>After activation, the plugin will usually appear in one of these locations:</p>
      <ul>
        <li><strong>Settings → [Plugin Name]</strong></li>
        <li><strong>Tools → [Plugin Name]</strong></li>
        <li>or as its own left-side admin menu entry</li>
      </ul>
      <p>The exact location depends on the plugin. For example, UpdraftPlus places its backup screen under <strong>Settings → UpdraftPlus Backups</strong>.</p>

      <h4 class="h6 mt-4 mb-2">What the backup should include</h4>
      <p>A full backup should include at least:</p>
      <ul>
        <li><strong>database</strong></li>
        <li><strong>WordPress files</strong></li>
        <li><strong>plugins</strong></li>
        <li><strong>themes</strong></li>
        <li><strong>uploads / media</strong></li>
      </ul>
      <p>The main site content is usually stored inside the WordPress installation, especially under:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>wp-content/</code><br />
        <code>wp-content/plugins/</code><br />
        <code>wp-content/themes/</code><br />
        <code>wp-content/uploads/</code>
      </div>

      <h4 class="h6 mt-4 mb-2">Configure external backup storage</h4>
      <p>Inside the plugin screen, look for sections such as:</p>
      <ul>
        <li><strong>Settings</strong></li>
        <li><strong>Storage</strong></li>
        <li><strong>Remote Storage</strong></li>
        <li><strong>Destination</strong></li>
      </ul>
      <p>This is where you define where backups are stored. It is strongly recommended to choose an <strong>offsite backup</strong> destination, meaning cloud storage, a remote server, or another external location, rather than storing backups only on the same WordPress server.</p>

      <h4 class="h6 mt-4 mb-2">Create the first backup</h4>
      <p>In the plugin dashboard, look for a button such as:</p>
      <ul>
        <li><strong>Backup Now</strong></li>
        <li><strong>Run Backup</strong></li>
        <li><strong>Create Backup</strong></li>
      </ul>
      <p>Before updating WordPress core, plugins, themes, or making major changes, it is recommended to run an additional <strong>manual backup</strong>.</p>

      <h4 class="h6 mt-4 mb-2">Set up automatic backups</h4>
      <p>Inside the plugin, look for options such as:</p>
      <ul>
        <li><strong>Schedule</strong></li>
        <li><strong>Backup Schedule</strong></li>
        <li><strong>Files Schedule</strong></li>
        <li><strong>Database Schedule</strong></li>
      </ul>
      <p>It is a good practice to configure automatic backups for both files and database, especially when the plugin allows separate schedules.</p>

      <h4 class="h6 mt-4 mb-2">Restore the site from the plugin</h4>
      <p>When a restore is needed, open the plugin and look for areas such as:</p>
      <ul>
        <li><strong>Existing Backups</strong></li>
        <li><strong>Restore</strong></li>
        <li><strong>Backup / Restore</strong></li>
        <li><strong>Import Backup</strong></li>
      </ul>
      <p>In some plugins, such as UpdraftPlus, the restore path is:<br /><strong>Settings → UpdraftPlus Backups → Existing Backups → Restore</strong>.<br />If the backup files are not listed, some plugins also allow manual upload through an option such as <strong>Upload backup files</strong> before starting the restore.</p>

      <h4 class="h6 mt-4 mb-2">Recommended checks after restore</h4>
      <p>After restoring, check at minimum:</p>
      <ul>
        <li>that the main site loads</li>
        <li>that <code>/wp-admin</code> loads</li>
        <li>that plugins and themes load correctly</li>
        <li>that images from <code>wp-content/uploads/</code> are available</li>
        <li>that there is no database connection issue</li>
      </ul>
      <p>Useful paths to verify:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>/wp-admin</code><br />
        <code>/wp-content/uploads/</code><br />
        <code>/wp-content/plugins/</code><br />
        <code>/wp-content/themes/</code>
      </div>
    `
  },
  {
    id: 5,
    image: 'assets/images/blog/wordpress-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'WordPress Upload Guide / מדריך העלאת אתר WordPress',
    titleHe: 'מדריך העלאת אתר WordPress',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">מדריך העלאת אתר WordPress</h3>
        <p>שירות האחסון כולל פאנל ניהול מוכן מראש, כך שאין צורך להקים סביבת שרת ידנית כדי להתחיל לעבוד עם WordPress. לאחר הפעלת החשבון, הלקוח מקבל פרטי גישה לפאנל, ודרך הממשק ניתן לנהל דומיינים, קבצים, מסדי נתונים, תיבות דוא״ל, תעודות SSL ואת התקנת WordPress עצמה. בטקסט שסיפקת מצוין שגם כתובת ההתחברות לפאנל היא כתובת ייעודית תחת הדומיין, ושהממשק משתנה לפי סוג פרטי ההתחברות של החשבון.</p>

        <h4 class="h6 mt-4 mb-2">1. התחברות לפאנל הניהול</h4>
        <p>לאחר הפעלת השירות, תקבלו במייל את פרטי ההתחברות לחשבון האחסון. בדרך כלל ההתחברות לפאנל מתבצעת דרך כתובת ייעודית כגון:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>https://spanel.epicfinal-cloud.com/spanel</code>
        </div>
        <p>או דרך כתובת הניהול שסופקה לכם במייל הפתיחה. לאחר ההתחברות ניתן לראות את פרטי החשבון, שימוש במשאבים, וכלי הניהול העיקריים. הטקסט שסיפקת מתאר שמסך הבית של הפאנל מציג מידע כללי על החשבון ושימוש נוכחי במשאבים, ושכלי הניהול מסודרים באזורים נפרדים בממשק.</p>

        <h4 class="h6 mt-4 mb-2">2. חיבור הדומיין לאחסון</h4>
        <p>לפני התקנת WordPress, יש לוודא שהדומיין מצביע נכון לחשבון האחסון. לאחר הפעלת החשבון, מקובל לקבל במייל הפתיחה את שרתי השמות או את הנחיות ה־DNS שיש להגדיר. אחרי שהדומיין מוגדר נכון, אפשר להמשיך להתקנת האתר דרך הפאנל. הטקסט שסיפקת מתאר במפורש שדומיין חייב להיות מוגדר נכון, ושלאחר הפנייתו לשרתי השמות המתאימים ניתן לנהל את התוכן שלו דרך הפאנל.</p>
        <p>אם האתר הראשי יותקן על הדומיין הראשי, הנתיב הנפוץ של הקבצים יהיה בדרך כלל:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>public_html/</code>
        </div>
        <p>אם רוצים להעלות אתר נוסף או אזור נפרד, ניתן להשתמש גם בתיקיית משנה, לדוגמה:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>public_html/blog/</code><br />
          <code>public_html/store/</code>
        </div>
        <p>אם מדובר בדומיין נוסף תחת אותו חשבון, נהוג להוסיף אותו תחילה דרך אזור <strong>Addon Domains</strong>, ואז להפנות אותו לספרייה המתאימה תחת תיקיית השורש של החשבון. גם זה מופיע מפורשות בטקסט שסיפקת.</p>

        <h4 class="h6 mt-4 mb-2">3. בחירת שיטת ההתקנה של WordPress</h4>
        <p>בפאנל מוכן מראש, WordPress בדרך כלל לא מותקן ידנית “מאפס”, אלא דרך אחד משני כלים: הראשון הוא <strong>WordPress Manager</strong> ייעודי, והשני הוא <strong>Auto Installer</strong> להתקנת אפליקציות. בטקסט שסיפקת מופיע שבמערכת קיימים גם מנהל WordPress מובנה וגם מתקין יישומים אוטומטי למאות יישומים נוספים.</p>
        <p>במהלך ההתקנה דרך הפאנל, בדרך כלל תתבקשו לבחור:</p>
        <ul>
          <li>את הדומיין שעליו יותקן האתר</li>
          <li>את תיקיית ההתקנה</li>
          <li>את שם האתר</li>
          <li>את שפת האתר</li>
          <li>את שם המשתמש והסיסמה של מנהל המערכת</li>
          <li>את כתובת הדוא״ל הניהולית</li>
          <li>לעיתים גם אפשרויות כמו עדכונים אוטומטיים, תוספים התחלתיים או תבנית בסיסית</li>
        </ul>
        <p>אם אתם מתקינים את האתר הראשי של הדומיין, לרוב יש להשאיר את שדה התיקייה ריק או לבחור את שורש האתר, כדי שההתקנה תתבצע ב־<code>public_html/</code> ולא בתיקייה פנימית נוספת.</p>

        <h4 class="h6 mt-4 mb-2">4. יצירת מסד נתונים, אם נדרש</h4>
        <p>בחלק מהפאנלים, תהליך ההתקנה של WordPress יוצר עבורכם אוטומטית את מסד הנתונים. במקרים אחרים, ייתכן שתצטרכו ליצור אותו קודם דרך אזור <strong>MySQL Databases</strong>. לפי הטקסט שסיפקת, הפאנל מאפשר ליצור מסדי נתונים חדשים, ליצור משתמשים למסדי נתונים, ולהגדיר הרשאות לכל משתמש ולכל מסד.</p>
        <p>ערכים נפוצים:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>Database Name: youraccount_wp01</code><br />
          <code>Database User: youraccount_wp01</code><br />
          <code>Database Host: localhost</code>
        </div>
        <p>לאחר מכן, אם יש צורך בגישה ישירה למסד הנתונים, ניתן בדרך כלל לעבוד דרך:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>phpMyAdmin</code>
        </div>

        <h4 class="h6 mt-4 mb-2">5. מיקום הקבצים ונתיבי WordPress</h4>
        <p>לאחר ההתקנה, קבצי WordPress יימצאו בדרך כלל בנתיב ההתקנה שנבחר.</p>
        <p>אם האתר מותקן בדומיין הראשי:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>public_html/</code>
        </div>
        <p>אם האתר מותקן בתיקיית משנה:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>public_html/blog/</code>
        </div>
        <p>נתיבים חשובים שכדאי להכיר:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>public_html/wp-config.php</code><br />
          <code>public_html/wp-admin/</code><br />
          <code>public_html/wp-content/</code><br />
          <code>public_html/wp-content/plugins/</code><br />
          <code>public_html/wp-content/themes/</code><br />
          <code>public_html/wp-content/uploads/</code>
        </div>

        <h4 class="h6 mt-4 mb-2">6. הפעלת SSL ו־HTTPS</h4>
        <p>לאחר שהדומיין מצביע נכון לאחסון, ניתן להפעיל תעודת SSL דרך אזור <strong>SSL Certificates</strong> בפאנל. בטקסט שסיפקת מופיע שבחלק מהמערכות, אם הדומיין כבר מצביע לשרתי השמות הנכונים, תעודת SSL יכולה להיות מותקנת ומוגדרת אוטומטית בתוך עד 24 שעות.</p>
        <p>לאחר שה־SSL פעיל, כתובות העבודה התקינות צריכות להיות למשל:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>https://yourdomain.com</code><br />
          <code>https://yourdomain.com/wp-admin</code>
        </div>

        <h4 class="h6 mt-4 mb-2">7. כניסה ראשונה ל־WordPress</h4>
        <p>בסיום ההתקנה, ניתן להתחבר לאזור הניהול של WordPress דרך:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>https://yourdomain.com/wp-admin</code>
        </div>
        <p>או, אם ההתקנה בוצעה בתיקיית משנה:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>https://yourdomain.com/blog/wp-admin</code>
        </div>
        <p>לאחר הכניסה הראשונה מומלץ לבדוק שהאתר נפתח תקין, שה־admin נטען ב־HTTPS, לעדכן את שם האתר ותיאור האתר, להתקין תבנית, להתקין רק תוספים נדרשים, למחוק תוספים ותבניות שאינם בשימוש, ולהפעיל עדכונים אוטומטיים אם האפשרות זמינה בפאנל או במנהל WordPress.</p>

        <h4 class="h6 mt-4 mb-2">8. העלאת קבצים וניהול האתר דרך הפאנל</h4>
        <p>אם יש צורך להעלות קבצי אתר, תבנית, קובצי מדיה או קובצי גיבוי, ניתן לעשות זאת דרך <strong>File Manager</strong> בפאנל. לפי הטקסט שסיפקת, דרך ממשק זה אפשר להעלות ולהוריד קבצים, ליצור תיקיות, לשנות הרשאות ואף לערוך קבצים ישירות מתוך הפאנל. עבור עבודה בכמות גדולה יותר של קבצים, ניתן להשתמש גם בחשבונות <strong>FTP</strong> ייעודיים.</p>

        <h4 class="h6 mt-4 mb-2">9. גיבויים ושחזור</h4>
        <p>הפאנל כולל גם כלים של <strong>Backup and Restore</strong>, שמאפשרים לשחזר את האתר במקרה של תקלה, מחיקה, שינוי לא רצוי או עדכון שגרם לבעיה. לכן לפני שינויים משמעותיים, עדכונים או מעבר תבנית, מומלץ לוודא שקיים גיבוי עדכני.</p>

        <h4 class="h6 mt-4 mb-2">10. תקלות נפוצות לאחר העלאה</h4>
        <p>אם האתר לא עולה כמו שצריך לאחר ההתקנה, כדאי לבדוק:</p>
        <ul>
          <li>שהדומיין מצביע נכון</li>
          <li>שההתקנה בוצעה בנתיב הנכון</li>
          <li>ש־SSL הותקן בהצלחה</li>
          <li>שמסד הנתונים נוצר והוגדר נכון</li>
          <li>ש־WordPress לא הותקן בטעות בתיקייה לא נכונה</li>
          <li>שהכתובת הנכונה לכניסה היא <code>wp-admin</code> תחת הנתיב שבו בוצעה ההתקנה</li>
        </ul>
      </div>

      <hr class="my-5" />

      <h3 class="h5 mb-3">WordPress Launch Guide</h3>
      <p>Your hosting service includes a ready-to-use hosting control panel, so there is no need to manually build a server environment before launching WordPress. Once the account is activated, the customer receives panel login credentials, and from that interface it is possible to manage domains, files, databases, email accounts, SSL certificates, and the WordPress installation itself. Your source text also states that the panel is accessed through a dedicated login path under the domain, and that the visible interface depends on the type of credentials used.</p>

      <h4 class="h6 mt-4 mb-2">1. Log in to the hosting panel</h4>
      <p>After the service is activated, you will receive the hosting account login details by email. In many cases, the panel login address is something like:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>https://spanel.epicfinal-cloud.com/spanel</code>
      </div>
      <p>or another management URL provided in the welcome email. After login, the panel usually shows the account overview, current resource usage, and access to the main management tools.</p>

      <h4 class="h6 mt-4 mb-2">2. Connect the domain to the hosting account</h4>
      <p>Before installing WordPress, make sure the domain is correctly pointed to the hosting account. After activation, customers typically receive the required nameserver or DNS instructions in the welcome email. Once the domain is routed correctly, the website setup can continue through the hosting panel.</p>
      <p>If the main website will be installed on the main domain, the usual file path is:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>public_html/</code>
      </div>
      <p>If you want to install WordPress inside a subdirectory, the path may be:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>public_html/blog/</code><br />
        <code>public_html/store/</code>
      </div>

      <h4 class="h6 mt-4 mb-2">3. Choose the WordPress installation method</h4>
      <p>With a ready hosting panel, WordPress is usually installed through a dedicated <strong>WordPress Manager</strong> or through an <strong>Auto Installer</strong> for web applications. During installation, you will usually choose the target domain, installation directory, site title, language, admin username and password, administrative email, and in some systems also automatic updates or starter options.</p>

      <h4 class="h6 mt-4 mb-2">4. Create the database, if required</h4>
      <p>In some hosting panels, the WordPress installer creates the database automatically. In other cases, you may need to create it first through the <strong>MySQL Databases</strong> section.</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>Database Name: youraccount_wp01</code><br />
        <code>Database User: youraccount_wp01</code><br />
        <code>Database Host: localhost</code>
      </div>
      <p>If direct database access is required later, it is commonly available through:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>phpMyAdmin</code>
      </div>

      <h4 class="h6 mt-4 mb-2">5. File paths and WordPress location</h4>
      <p>After installation, the WordPress files will usually be stored in the selected installation path.</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>public_html/wp-config.php</code><br />
        <code>public_html/wp-admin/</code><br />
        <code>public_html/wp-content/</code><br />
        <code>public_html/wp-content/plugins/</code><br />
        <code>public_html/wp-content/themes/</code><br />
        <code>public_html/wp-content/uploads/</code>
      </div>

      <h4 class="h6 mt-4 mb-2">6. Enable SSL and HTTPS</h4>
      <p>Once the domain points correctly to the hosting account, you can enable an SSL certificate from the <strong>SSL Certificates</strong> area in the hosting panel. After SSL is active, the correct working URLs should be:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>https://yourdomain.com</code><br />
        <code>https://yourdomain.com/wp-admin</code>
      </div>

      <h4 class="h6 mt-4 mb-2">7. First WordPress login</h4>
      <p>After installation is complete, the WordPress admin area is usually available at:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>https://yourdomain.com/wp-admin</code>
      </div>
      <p>or, for a subdirectory installation:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>https://yourdomain.com/blog/wp-admin</code>
      </div>

      <h4 class="h6 mt-4 mb-2">8. Uploading files and managing the website through the panel</h4>
      <p>If you need to upload website files, themes, media, or backup archives, this can usually be done through the <strong>File Manager</strong> in the panel. For larger file workflows, <strong>FTP accounts</strong> can also be created and used.</p>

      <h4 class="h6 mt-4 mb-2">9. Backups and restore</h4>
      <p>The hosting panel also includes <strong>Backup and Restore</strong> tools, which can be used to recover the website after a mistake, unwanted change, failed update, or data loss event.</p>

      <h4 class="h6 mt-4 mb-2">10. Common post-installation issues</h4>
      <p>If the website does not load correctly after installation, check that the domain points correctly, that WordPress was installed in the correct path, that SSL was successfully activated, that the database was created and configured correctly, and that the correct admin path is being used under the actual installation location.</p>
    `
  },
  {
    id: 4,
    image: 'assets/images/blog/hosting-icon.svg',
    date: '15 Apr',
    category: 'Tech Docs',
    title: 'Website Hosting / אחסון אתרים',
    titleHe: 'אחסון אתרים',
    author: 'EpicFinal Tech',
    views: 0,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">ניהול אחסון אתר</h3>
        <p>מערכת ניהול האחסון מאפשרת לכם לנהל את רוב היבטי החשבון והשירותים שלכם ממקום אחד, בצורה נוחה, ברורה ומאובטחת. דרך ממשק הניהול ניתן לבצע פעולות שוטפות הקשורות לאתר, לדומיינים, לדואר האלקטרוני, לקבצים, למסדי נתונים, לאבטחה, לגיבויים ולכלים מתקדמים נוספים.</p>
        <p>לאחר ההתחברות למערכת, ניתן לראות מידע כללי על חשבון האחסון, כולל שימוש נוכחי במשאבים, ולגשת לכלי הניהול השונים דרך לוחות עבודה מסודרים. בחלק מהמערכות ניתן גם להתאים את סידור הכלים בממשק, כך שהפעולות הנפוצות יהיו נגישות יותר.</p>

        <h4 class="h6 mt-4 mb-2">ניהול אתרים ודומיינים</h4>
        <p>ממשק הניהול מאפשר לנהל את הדומיין הראשי של החשבון, להוסיף <strong>Addon Domains</strong> לצורך אחסון אתרים נוספים תחת אותו חשבון, וליצור <strong>Subdomains</strong> עבור אזורים שונים באתר, כגון <code>blog.example.com</code> או <code>shop.example.com</code>. ניתן גם להגדיר <strong>Redirects</strong> קבועים או זמניים מבלי לערוך ידנית קבצי מערכת כמו <code>.htaccess</code>.</p>
        <p>בנוסף, עורך ה־DNS מאפשר לנהל רשומות מסוג <strong>A</strong>, <strong>MX</strong>, <strong>CNAME</strong> ו־<strong>TXT</strong>, וכך לשלוט בהפניית תעבורת האתר, תתי־הדומיין ושירותי הדואר האלקטרוני ליעדים הנכונים. לאחר הפעלת החשבון, מקובל לקבל במייל פתיחה את פרטי שרתי השמות שיש להגדיר עבור הדומיין, ולאחר שהדומיין מצביע נכון, ניתן להשלים את הגדרות האתר מתוך הממשק.</p>

        <h4 class="h6 mt-4 mb-2">ניהול דואר אלקטרוני</h4>
        <p>ממשק האחסון כולל בדרך כלל אזור ייעודי לניהול תיבות דואר אלקטרוני המשויכות לדומיין. ניתן ליצור תיבות חדשות, לעדכן סיסמאות, ולנהל את כלל החשבונות הקיימים מאותו מקום. בנוסף, קיימים כלים כמו <strong>Autoresponders</strong>, <strong>Forwarders</strong> ו־<strong>Default Address</strong> לצורך שליטה באופן הטיפול בהודעות נכנסות.</p>
        <p>כאשר משתמשים בספק דואר חיצוני, ניתן לעדכן את מסלול הדואר דרך הגדרות <strong>Mail Route</strong> כך שהודעות יעברו לשרת המתאים. בחלק מהמערכות יש גם הגנה מובנית מפני דואר זבל, לצד אפשרות לבניית מסננים מותאמים אישית עבור הודעות לא רצויות.</p>

        <h4 class="h6 mt-4 mb-2">ניהול קבצים וגיבויים</h4>
        <p>דרך <strong>File Manager</strong> ניתן להעלות ולהוריד קבצים, ליצור תיקיות חדשות, לשנות הרשאות, ולערוך קבצים ישירות מתוך הדפדפן. עבור ניהול כמויות גדולות יותר של קבצים או עבודה שוטפת מול סביבת האתר, ניתן להשתמש גם בחשבונות <strong>FTP</strong> ייעודיים. המערכת מאפשרת ליצור ולנהל מספר חשבונות FTP לפי הצורך.</p>
        <p>בנוסף, כלי <strong>Backup and Restore</strong> מסייעים ביצירה ושחזור של גיבויים במקרה של תקלה, שינוי לא רצוי או צורך בשחזור נתונים. בחלק מממשקי הניהול ניתן גם לצפות בנתוני צריכת שטח האחסון של החשבון מתוך אזור הקבצים.</p>

        <h4 class="h6 mt-4 mb-2">ניהול מסדי נתונים</h4>
        <p>אתרים ואפליקציות מודרניים רבים דורשים עבודה עם מסדי נתונים, ולכן הממשק כולל בדרך כלל אזור לניהול <strong>MySQL Databases</strong>. דרך אזור זה ניתן ליצור מסדי נתונים חדשים, להגדיר משתמשים ייעודיים, ולהקצות הרשאות גישה לכל משתמש ומסד נתונים.</p>
        <p>לניהול הנתונים עצמם, מקובל לשלב כלי כמו <strong>phpMyAdmin</strong>, המאפשר גישה נוחה למסדי נתונים מסוג MySQL או MariaDB דרך הדפדפן.</p>

        <h4 class="h6 mt-4 mb-2">כלים נוספים לניהול האתר</h4>
        <p>מעבר לפעולות הבסיסיות, מערכות ניהול אחסון רבות כוללות כלים נוספים שנועדו להקל על הקמה ותחזוקה של אתרים. לדוגמה, ניתן למצוא מנהל ייעודי ל־<strong>WordPress</strong> שמאפשר התקנה מהירה, הפעלת עדכונים אוטומטיים, ולעיתים גם כלי אבטחה שמונעים שינוי לא מורשה בקבצי האתר לאחר ההקמה.</p>
        <p>כאשר לא עובדים עם WordPress, ניתן לעיתים להשתמש גם ב־<strong>Auto Installer</strong> להתקנת מאות יישומי ווב אחרים בכמה לחיצות. בנוסף, ניתן לנהל <strong>SSL Certificates</strong> ולהפעיל HTTPS עבור האתר. במקרים מסוימים, אם הדומיין כבר מצביע לשרתי השמות הנכונים, תעודת SSL יכולה להיות מותקנת ומוגדרת אוטומטית בתוך עד 24 שעות.</p>
        <p>למשתמשים מתקדמים יותר, עשויות להיות זמינות גם אפשרויות ליצירת <strong>Cron Jobs</strong>, בחירת גרסת <strong>PHP</strong>, ועריכת קובץ <strong>PHP.ini</strong> לצורך התאמת סביבת הריצה של האתר.</p>

        <h4 class="h6 mt-4 mb-2">ניהול בסביבת VPS מנוהל</h4>
        <p>כאשר האחסון מבוסס על <strong>Managed Cloud VPS</strong>, ממשק הניהול עשוי לכלול גם שכבת ניהול ברמת השרת עצמו. במצב כזה, הלקוח אינו מנהל רק אתר בודד, אלא יכול לקבל גישה לכלים המאפשרים שליטה בתשתית הווירטואלית שעליה פועלים החשבונות והאתרים.</p>
        <p>מסך הבית של ממשק הניהול ברמת השרת משמש בדרך כלל כ־Dashboard, שבו ניתן לצפות בשימוש בזמן אמת במשאבי השרת, כגון <strong>CPU</strong>, <strong>RAM</strong> ושטח דיסק, לצד רשימת החשבונות הפעילים על השרת. לעיתים יש גם אפשרות לחיפוש מהיר בין כלי הניהול.</p>

        <h4 class="h6 mt-4 mb-2">ניהול השרת הווירטואלי</h4>
        <p>באזור ניהול השרת ניתן לצפות במידע מפורט על סביבת השרת, כולל מערכת ההפעלה שעליה הוא רץ ומצב ניצול המשאבים. בנוסף, ניתן למצוא כלים להגדרות אבטחה כגון <strong>Two-Factor Authentication</strong> ו־<strong>CAPTCHA</strong> עבור קבוצות משתמשים שונות. בחלק מהממשקים יש גם אזורים ייעודיים לניהול <strong>Branding</strong> ו־<strong>Packages</strong>, במיוחד עבור מפעילים או משווקים של שירותי אחסון.</p>
        <p>אזור <strong>Server Status</strong> מציג את סטטוס השירותים הפעילים על השרת, ואם אחד מהם אינו פועל כשורה, ניתן לנסות להפעיל אותו מחדש דרך <strong>Restart Service</strong>. אם יש צורך, ניתן גם לבצע <strong>Restart Server</strong> לשרת כולו. בנוסף, אזור <strong>Resource Usage</strong> מספק נתונים מפורטים יותר על העומס והשימוש במשאבים לאורך זמן.</p>
        <p>במקרים שבהם מספר אנשים צריכים לנהל את השרת, ניתן ליצור <strong>Admin Accounts</strong> נוספים. בחלק מהמערכות יש גם תמיכה ב־<strong>API Tokens</strong> לצורך אינטגרציה עם מערכות צד שלישי ויישומים נוספים.</p>

        <h4 class="h6 mt-4 mb-2">ניהול חשבונות בשרת</h4>
        <p>אזור <strong>Accounts Management</strong> נועד לשליטה בחשבונות המתארחים על השרת. ניתן ליצור חשבון חדש על ידי הזנת הדומיין הראשי של החשבון, בחירת שם משתמש וסיסמה, והגדרת מגבלות כגון שטח דיסק, מספר <strong>Inodes</strong>, מספר מסדי נתונים, מספר דומיינים נוספים ומספר תיבות דואר.</p>
        <p>לאחר יצירת החשבונות, ניתן לנהל אותם דרך אזור <strong>Manage Accounts</strong>: לעדכן שם משתמש, לשנות סיסמה, להחליף דומיין ראשי, לאפשר גישת <strong>SSH</strong>, ולהתאים את המשאבים שהוקצו לכל חשבון. במידת הצורך ניתן גם לבצע <strong>Suspend</strong>, <strong>Unsuspend</strong> או <strong>Terminate</strong> לחשבונות בודדים.</p>
        <p>בחלק מהממשקים ניתן גם לראות רשימה של שירותי SQL פעילים, לנהל רישוי של כלים כמו <strong>Softaculous</strong>, ואף לשנות את שרת הווב לפי אפשרויות המערכת והביצועים הרצויים.</p>
      </div>

      <hr class="my-5" />

      <h3 class="h5 mb-3">Website Hosting Management</h3>
      <p>The hosting management system allows users to control most aspects of their hosting account and services from a single interface in a secure and user-friendly way. Through the control panel, users can typically manage websites, domains, email services, files, databases, backups, security settings, and a range of advanced hosting tools.</p>
      <p>After signing in, users can view general account information, monitor current resource usage, and access the various management tools through organized dashboard sections. In some systems, the layout of these tools can also be adjusted for easier day-to-day access.</p>

      <h4 class="h6 mt-4 mb-2">Website and Domain Management</h4>
      <p>The hosting interface usually makes it possible to manage the account’s main domain, add <strong>addon domains</strong> to host additional websites under the same account, and create <strong>subdomains</strong> for separate website sections such as <code>blog.example.com</code> or <code>shop.example.com</code>. It may also include a <strong>redirects</strong> tool for creating temporary or permanent redirects without manually editing files such as <code>.htaccess</code>.</p>
      <p>In addition, the DNS management area generally includes support for records such as <strong>A</strong>, <strong>MX</strong>, <strong>CNAME</strong>, and <strong>TXT</strong>, allowing users to control how websites, subdomains, and email services are routed. After the hosting account is activated, users commonly receive a welcome email containing the required nameserver information, and once the domain points correctly, the rest of the website setup can be completed inside the panel.</p>

      <h4 class="h6 mt-4 mb-2">Email Management</h4>
      <p>The hosting environment usually includes a dedicated section for managing domain-based email accounts. Users can create new mailboxes, update passwords, and manage all existing email accounts from one place. Additional tools such as <strong>Autoresponders</strong>, <strong>Forwarders</strong>, and <strong>Default Address</strong> settings make it possible to control how incoming messages are handled.</p>
      <p>When a third-party email provider is used, the <strong>Mail Route</strong> setting can be adjusted so messages are delivered to the correct external service. Some systems also offer built-in spam filtering and custom email rules for handling unwanted messages more effectively.</p>

      <h4 class="h6 mt-4 mb-2">File Management and Backups</h4>
      <p>Through the <strong>File Manager</strong>, users can upload and download files, create folders, change permissions, and edit files directly in the browser. For larger file operations or ongoing workflow needs, the system may also support <strong>FTP accounts</strong>, and in many cases multiple FTP accounts can be created and managed as needed.</p>
      <p>The <strong>Backup and Restore</strong> tools help recover data in case of mistakes, unwanted changes, or service issues. Some control panels also provide storage usage statistics within the file management section.</p>

      <h4 class="h6 mt-4 mb-2">Database Management</h4>
      <p>Modern websites and applications often require databases, so hosting control panels commonly include a section for managing <strong>MySQL databases</strong>. From there, users can create new databases, define dedicated database users, and assign permissions for each database and user combination.</p>
      <p>For direct database administration, systems often integrate tools such as <strong>phpMyAdmin</strong>, allowing users to manage MySQL or MariaDB data from a browser-based interface.</p>

      <h4 class="h6 mt-4 mb-2">Additional Website Tools</h4>
      <p>Beyond the core functionality, many hosting panels include additional tools that make website deployment and maintenance easier. For example, a built-in <strong>WordPress manager</strong> may provide fast installation, automatic updates, and in some environments even security features designed to prevent unauthorized file changes after deployment.</p>
      <p>When WordPress is not being used, an <strong>auto installer</strong> may still be available to deploy hundreds of other web applications with minimal setup. Users can also manage <strong>SSL certificates</strong> and enable HTTPS for their websites. In some cases, once the domain points to the correct nameservers, an SSL certificate can be installed and configured automatically within up to 24 hours.</p>
      <p>More advanced users may also have access to <strong>Cron Jobs</strong>, <strong>PHP version</strong> selection, and <strong>PHP.ini</strong> editing to fine-tune the hosting environment.</p>

      <h4 class="h6 mt-4 mb-2">Managed VPS Environment</h4>
      <p>When hosting is provided on top of a <strong>managed cloud VPS</strong>, the control interface may also include server-level management features. In this case, the user is not only managing a website, but may also have access to tools for controlling the virtual infrastructure that powers the hosted accounts and services.</p>
      <p>The main page of the server management interface often acts as a dashboard, showing live resource usage such as <strong>CPU</strong>, <strong>RAM</strong>, and disk space, along with a list of active accounts hosted on the server. Some systems also include a search feature to help users quickly find management tools.</p>

      <h4 class="h6 mt-4 mb-2">Virtual Server Management</h4>
      <p>Within the server management section, users can usually access more detailed information about the server environment, including the operating system in use and the current resource allocation. Security-related options may also be available, such as <strong>two-factor authentication</strong> and <strong>CAPTCHA</strong> settings for different user groups. Some platforms also include sections for <strong>branding</strong> and <strong>packages</strong>, especially for resellers or providers managing multiple customers.</p>
      <p>The <strong>Server Status</strong> area typically shows which services are currently running on the VPS. If a service encounters an issue, it may be restarted through a <strong>Restart Service</strong> tool. When necessary, the entire server can also be rebooted using a <strong>Restart Server</strong> option. A <strong>Resource Usage</strong> section may provide more detailed day-by-day statistics about server load and resource consumption.</p>
      <p>If more than one person needs administrative access, additional <strong>admin accounts</strong> can usually be created. Some systems also support <strong>API tokens</strong> for integration with third-party software and external applications.</p>

      <h4 class="h6 mt-4 mb-2">Account Management on the Server</h4>
      <p>The <strong>Accounts Management</strong> section is used to control the hosted accounts on the VPS. Creating a new account typically involves entering the main domain, selecting a username and password, and defining limits such as disk space, <strong>inodes</strong>, databases, addon domains, and email accounts.</p>
      <p>Once accounts are created, they can usually be managed through a <strong>Manage Accounts</strong> area where administrators can change usernames, update passwords, replace the main domain, enable <strong>SSH access</strong>, and adjust the allocated resources of each account. If needed, individual accounts can also be <strong>suspended</strong>, <strong>unsuspended</strong>, or <strong>terminated</strong>.</p>
      <p>Some systems may additionally provide visibility into active SQL services, license management for tools such as <strong>Softaculous</strong>, and even options to change the active web server depending on system capabilities and performance goals.</p>
    `
  },
  {
    id: 2,
    image: 'assets/images/blog/ssh-icon.svg',
    date: '15 Apr',
    category: 'Infrastructure',
    title: 'SSH Password Login to Key-Based Authentication',
    titleHe: 'התחברות לשרת עם סיסמה ב־SSH ואז מעבר למפתח',
    author: 'EpicFinal Tech',
    views: 120,
    comments: 0,
    content: `
      <div dir="rtl">
        <div style="display:inline-block; background:#fde68a; color:#5b4500; font-weight:700; padding:8px 14px; border-radius:999px; margin-bottom:16px;">English version below</div>
        <h3 class="h5 mb-3">התחברות לשרת עם סיסמה ב־SSH, ואז יצירת מפתח והחלפת ההתחברות למפתח</h3>
        <p>Windows כולל לקוח OpenSSH מובנה, וגם בלינוקס בדרך כלל עובדים עם <code>ssh</code> ו־<code>ssh-keygen</code>. SSH מצפין את התעבורה, ו־OpenSSH תומך גם בהתחברות עם סיסמה וגם בהתחברות עם מפתח ציבורי.</p>

        <h4 class="h6 mt-4 mb-2">מה צריך לפני שמתחילים</h4>
        <ul>
          <li>כתובת IP של השרת</li>
          <li>שם משתמש: <code>root</code></li>
          <li>סיסמה שקיבלתם במייל</li>
        </ul>

        <h4 class="h6 mt-4 mb-2">שלב 1: התחברות ראשונה עם סיסמה</h4>
        <p class="mb-2"><strong>Windows (PowerShell / Terminal):</strong></p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>ssh root@YOUR_SERVER_IP</code>
        </div>
        <p class="mb-2"><strong>Linux:</strong></p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>ssh root@YOUR_SERVER_IP</code>
        </div>
        <p>בפעם הראשונה תקבלו אזהרה על טביעת האצבע של השרת. מאשרים, ואז מזינים את הסיסמה שקיבלתם. SSH ב־OpenSSH משמש להתחברות מאובטחת מרחוק.</p>

        <h4 class="h6 mt-4 mb-2">שלב 2: יצירת מפתח SSH על המחשב שלכם</h4>
        <p class="mb-2"><strong>Windows:</strong></p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>ssh-keygen -t ed25519 -C "root@YOUR_SERVER_IP"</code>
        </div>
        <p class="mb-2"><strong>Linux:</strong></p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>ssh-keygen -t ed25519 -C "root@YOUR_SERVER_IP"</code>
        </div>
        <p>אם לא ציינתם מיקום אחר, OpenSSH שומר את הקבצים בתיקיית <code>~/.ssh</code>. ב־Windows כלי <code>ssh-keygen</code> יוצר זוג מפתחות ציבורי/פרטי, ובברירת המחדל נשמרים קבצי המפתח בתיקיית המשתמש.</p>
        <p class="mb-2"><strong>הקבצים שנוצרים:</strong></p>
        <ul>
          <li>מפתח פרטי: <code>~/.ssh/id_ed25519</code></li>
          <li>מפתח ציבורי: <code>~/.ssh/id_ed25519.pub</code></li>
        </ul>

        <h4 class="h6 mt-4 mb-2">שלב 3: הצגת המפתח הציבורי מהמחשב המקומי</h4>
        <p class="mb-2"><strong>Windows (PowerShell):</strong></p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>type $env:USERPROFILE\\.ssh\\id_ed25519.pub</code>
        </div>
        <p class="mb-2"><strong>Linux:</strong></p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>cat ~/.ssh/id_ed25519.pub</code>
        </div>
        <p>העתיקו את כל התוכן של המפתח הציבורי, בשורה אחת מלאה.</p>

        <h4 class="h6 mt-4 mb-2">שלב 4: הוספת המפתח לשרת</h4>
        <p>אחרי שהתחברתם לשרת עם הסיסמה, הריצו על השרת:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>mkdir -p ~/.ssh</code><br />
          <code>chmod 700 ~/.ssh</code><br />
          <code>nano ~/.ssh/authorized_keys</code>
        </div>
        <p>הדביקו בתוך הקובץ את המפתח הציבורי שהעתקתם מהמחשב, שמרו, ואז הריצו:</p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>chmod 600 ~/.ssh/authorized_keys</code>
        </div>
        <p>OpenSSH משתמש בקובץ <code>authorized_keys</code> כדי לאפשר התחברות עם מפתח ציבורי.</p>

        <h4 class="h6 mt-4 mb-2">שלב 5: התחברות מחדש עם המפתח</h4>
        <p>צאו מהחיבור הקודם והתחברו שוב:</p>
        <p class="mb-2"><strong>Windows:</strong></p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>ssh -i $env:USERPROFILE\\.ssh\\id_ed25519 root@YOUR_SERVER_IP</code>
        </div>
        <p class="mb-2"><strong>Linux:</strong></p>
        <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-right: 4px solid #005c82;">
          <code>ssh -i ~/.ssh/id_ed25519 root@YOUR_SERVER_IP</code>
        </div>
        <p>אם הכול תקין, תתחברו בלי להשתמש בסיסמה של השרת, אלא עם המפתח הפרטי ששמור אצלכם במחשב. OpenSSH for Windows מתעד במפורש שימוש ב־<code>ssh-keygen</code> ליצירת מפתחות ובהתחברות עם אימות מבוסס מפתח.</p>

        <h4 class="h6 mt-4 mb-2">חשוב</h4>
        <ul>
          <li>לא לשתף את הקובץ הפרטי <code>id_ed25519</code></li>
          <li>כן מעתיקים לשרת רק את הקובץ הציבורי <code>id_ed25519.pub</code></li>
          <li>מומלץ להגדיר גם passphrase למפתח בזמן היצירה, להגנה נוספת על המפתח הפרטי</li>
        </ul>
        <p>Microsoft ממליצה על ניהול נכון של מפתחות SSH ומפנה גם להנחיות אבטחה ייעודיות בנושא.</p>
      </div>

      <hr class="my-5" />

      <h3 class="h5 mb-3">Connect to a server with an SSH password, then switch to key-based login</h3>
      <p>Windows includes a built-in OpenSSH client, and Linux commonly uses the same <code>ssh</code> and <code>ssh-keygen</code> tools. SSH encrypts traffic, and OpenSSH supports both password authentication and public key authentication.</p>

      <h4 class="h6 mt-4 mb-2">Requirements</h4>
      <ul>
        <li>Server IP address</li>
        <li>Username: <code>root</code></li>
        <li>Password received by email</li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Step 1: First login with password</h4>
      <p class="mb-2"><strong>Windows (PowerShell / Terminal):</strong></p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>ssh root@YOUR_SERVER_IP</code>
      </div>
      <p class="mb-2"><strong>Linux:</strong></p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>ssh root@YOUR_SERVER_IP</code>
      </div>
      <p>The first time, you will be asked to trust the server fingerprint. Accept it, then enter the password from the email. SSH is the standard secure protocol for remote terminal access.</p>

      <h4 class="h6 mt-4 mb-2">Step 2: Generate an SSH key on your computer</h4>
      <p class="mb-2"><strong>Windows:</strong></p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>ssh-keygen -t ed25519 -C "root@YOUR_SERVER_IP"</code>
      </div>
      <p class="mb-2"><strong>Linux:</strong></p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>ssh-keygen -t ed25519 -C "root@YOUR_SERVER_IP"</code>
      </div>
      <p>If you do not choose a different path, the keys are stored in the <code>~/.ssh</code> directory by default. Microsoft documents that <code>ssh-keygen</code> creates the public/private key pair and stores it locally.</p>
      <p class="mb-2"><strong>Created files:</strong></p>
      <ul>
        <li>Private key: <code>~/.ssh/id_ed25519</code></li>
        <li>Public key: <code>~/.ssh/id_ed25519.pub</code></li>
      </ul>

      <h4 class="h6 mt-4 mb-2">Step 3: Show the public key from your local computer</h4>
      <p class="mb-2"><strong>Windows (PowerShell):</strong></p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>type $env:USERPROFILE\\.ssh\\id_ed25519.pub</code>
      </div>
      <p class="mb-2"><strong>Linux:</strong></p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>cat ~/.ssh/id_ed25519.pub</code>
      </div>
      <p>Copy the entire public key as a single line.</p>

      <h4 class="h6 mt-4 mb-2">Step 4: Add the key to the server</h4>
      <p>After logging in to the server with the password, run this on the server:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>mkdir -p ~/.ssh</code><br />
        <code>chmod 700 ~/.ssh</code><br />
        <code>nano ~/.ssh/authorized_keys</code>
      </div>
      <p>Paste your public key into the file, save it, then run:</p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>chmod 600 ~/.ssh/authorized_keys</code>
      </div>
      <p>OpenSSH uses the <code>authorized_keys</code> file to allow public key authentication.</p>

      <h4 class="h6 mt-4 mb-2">Step 5: Reconnect using the key</h4>
      <p>Disconnect and connect again:</p>
      <p class="mb-2"><strong>Windows:</strong></p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>ssh -i $env:USERPROFILE\\.ssh\\id_ed25519 root@YOUR_SERVER_IP</code>
      </div>
      <p class="mb-2"><strong>Linux:</strong></p>
      <div class="bg-light p-3 rounded mb-3" style="font-family: monospace; border-left: 4px solid #005c82;">
        <code>ssh -i ~/.ssh/id_ed25519 root@YOUR_SERVER_IP</code>
      </div>
      <p>If everything is correct, you will log in using the private key stored on your computer instead of the server password. Microsoft&apos;s OpenSSH documentation covers generating keys with <code>ssh-keygen</code> and using key-based authentication.</p>

      <h4 class="h6 mt-4 mb-2">Important</h4>
      <ul>
        <li>Never share the private key file <code>id_ed25519</code></li>
        <li>Only copy the public key <code>id_ed25519.pub</code> to the server</li>
        <li>It is recommended to protect the private key with a passphrase when creating it</li>
      </ul>
    `
  },
];

export default blogList;
